// Auto-generated from tools/grouplooper-out/courses.json by
// tools/normalize-grouplooper.mjs. DO NOT edit by hand — re-run the
// normalizer after refreshing the scrape.

import { Course } from "./types";

export const grouplooperCourses: Course[] = [
  {
    "id": "gl_allandale-golf-course",
    "name": "Allandale Golf Course",
    "city": "Innisfil",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 1,
        "yardage": 500
      },
      {
        "number": 2,
        "par": 4,
        "si": 9,
        "yardage": 375
      },
      {
        "number": 3,
        "par": 3,
        "si": 15,
        "yardage": 215
      },
      {
        "number": 4,
        "par": 4,
        "si": 11,
        "yardage": 375
      },
      {
        "number": 5,
        "par": 5,
        "si": 3,
        "yardage": 500
      },
      {
        "number": 6,
        "par": 3,
        "si": 17,
        "yardage": 155
      },
      {
        "number": 7,
        "par": 3,
        "si": 13,
        "yardage": 210
      },
      {
        "number": 8,
        "par": 4,
        "si": 7,
        "yardage": 395
      },
      {
        "number": 9,
        "par": 5,
        "si": 5,
        "yardage": 525
      }
    ],
    "tees": [
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 132,
        "rating": 35.4
      }
    ]
  },
  {
    "id": "gl_balm-beachway-golf-club",
    "name": "Balm Beachway Golf Club",
    "city": "Tiny",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 9,
        "yardage": 246
      },
      {
        "number": 2,
        "par": 3,
        "si": 13,
        "yardage": 101
      },
      {
        "number": 3,
        "par": 4,
        "si": 5,
        "yardage": 326
      },
      {
        "number": 4,
        "par": 4,
        "si": 7,
        "yardage": 230
      },
      {
        "number": 5,
        "par": 3,
        "si": 17,
        "yardage": 148
      },
      {
        "number": 6,
        "par": 5,
        "si": 3,
        "yardage": 343
      },
      {
        "number": 7,
        "par": 4,
        "si": 15,
        "yardage": 258
      },
      {
        "number": 8,
        "par": 4,
        "si": 11,
        "yardage": 267
      },
      {
        "number": 9,
        "par": 5,
        "si": 1,
        "yardage": 420
      }
    ]
  },
  {
    "id": "gl_barrie-country-club",
    "name": "Barrie Country Club",
    "city": "Barrie",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 9,
        "yardage": 350
      },
      {
        "number": 2,
        "par": 4,
        "si": 11,
        "yardage": 315
      },
      {
        "number": 3,
        "par": 3,
        "si": 15,
        "yardage": 141
      },
      {
        "number": 4,
        "par": 5,
        "si": 1,
        "yardage": 412
      },
      {
        "number": 5,
        "par": 3,
        "si": 17,
        "yardage": 142
      },
      {
        "number": 6,
        "par": 5,
        "si": 5,
        "yardage": 436
      },
      {
        "number": 7,
        "par": 3,
        "si": 13,
        "yardage": 112
      },
      {
        "number": 8,
        "par": 4,
        "si": 7,
        "yardage": 335
      },
      {
        "number": 9,
        "par": 5,
        "si": 3,
        "yardage": 412
      },
      {
        "number": 10,
        "par": 4,
        "si": 10,
        "yardage": 310
      },
      {
        "number": 11,
        "par": 4,
        "si": 14,
        "yardage": 286
      },
      {
        "number": 12,
        "par": 5,
        "si": 2,
        "yardage": 402
      },
      {
        "number": 13,
        "par": 3,
        "si": 16,
        "yardage": 140
      },
      {
        "number": 14,
        "par": 4,
        "si": 6,
        "yardage": 315
      },
      {
        "number": 15,
        "par": 4,
        "si": 4,
        "yardage": 311
      },
      {
        "number": 16,
        "par": 3,
        "si": 18,
        "yardage": 121
      },
      {
        "number": 17,
        "par": 4,
        "si": 8,
        "yardage": 303
      },
      {
        "number": 18,
        "par": 5,
        "si": 12,
        "yardage": 409
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 134,
        "rating": 74.1
      },
      {
        "id": "championship",
        "name": "Championship",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 132,
        "rating": 73.6
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 130,
        "rating": 73
      },
      {
        "id": "long-hybrid",
        "name": "Long Hybrid",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 129,
        "rating": 71.9
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 128,
        "rating": 70.9
      },
      {
        "id": "short-hyrbird",
        "name": "Short Hyrbird",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 125,
        "rating": 69.6
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 119,
        "rating": 67.7
      },
      {
        "id": "forward-hybrid",
        "name": "Forward Hybrid",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 116,
        "rating": 66.5
      },
      {
        "id": "yellow",
        "name": "Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 114,
        "rating": 65.4
      }
    ]
  },
  {
    "id": "gl_batteaux-creek-golf-club",
    "name": "Batteaux Creek Golf Club",
    "city": "Nottawa",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 7,
        "yardage": 364
      },
      {
        "number": 2,
        "par": 4,
        "si": 17,
        "yardage": 326
      },
      {
        "number": 3,
        "par": 5,
        "si": 11,
        "yardage": 491
      },
      {
        "number": 4,
        "par": 4,
        "si": 1,
        "yardage": 425
      },
      {
        "number": 5,
        "par": 3,
        "si": 15,
        "yardage": 168
      },
      {
        "number": 6,
        "par": 4,
        "si": 13,
        "yardage": 330
      },
      {
        "number": 7,
        "par": 5,
        "si": 5,
        "yardage": 484
      },
      {
        "number": 8,
        "par": 3,
        "si": 9,
        "yardage": 157
      },
      {
        "number": 9,
        "par": 4,
        "si": 3,
        "yardage": 399
      },
      {
        "number": 10,
        "par": 4,
        "si": 4,
        "yardage": 386
      },
      {
        "number": 11,
        "par": 4,
        "si": 10,
        "yardage": 354
      },
      {
        "number": 12,
        "par": 3,
        "si": 12,
        "yardage": 190
      },
      {
        "number": 13,
        "par": 5,
        "si": 2,
        "yardage": 565
      },
      {
        "number": 14,
        "par": 4,
        "si": 16,
        "yardage": 378
      },
      {
        "number": 15,
        "par": 4,
        "si": 6,
        "yardage": 363
      },
      {
        "number": 16,
        "par": 3,
        "si": 18,
        "yardage": 150
      },
      {
        "number": 17,
        "par": 5,
        "si": 14,
        "yardage": 457
      },
      {
        "number": 18,
        "par": 4,
        "si": 8,
        "yardage": 368
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 138,
        "rating": 73.3
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 134,
        "rating": 71.1
      }
    ]
  },
  {
    "id": "gl_bear-creek-golf-club--7",
    "name": "Bear Creek Golf Club",
    "city": "Utopia",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 259
      },
      {
        "number": 2,
        "par": 3,
        "si": 17,
        "yardage": 97
      },
      {
        "number": 3,
        "par": 5,
        "si": 3,
        "yardage": 384
      },
      {
        "number": 4,
        "par": 4,
        "si": 15,
        "yardage": 232
      },
      {
        "number": 5,
        "par": 4,
        "si": 9,
        "yardage": 256
      },
      {
        "number": 6,
        "par": 3,
        "si": 5,
        "yardage": 114
      },
      {
        "number": 7,
        "par": 4,
        "si": 13,
        "yardage": 268
      },
      {
        "number": 8,
        "par": 5,
        "si": 11,
        "yardage": 335
      },
      {
        "number": 9,
        "par": 3,
        "si": 7,
        "yardage": 118
      },
      {
        "number": 10,
        "par": 4,
        "si": 18,
        "yardage": 263
      },
      {
        "number": 11,
        "par": 4,
        "si": 6,
        "yardage": 232
      },
      {
        "number": 12,
        "par": 3,
        "si": 14,
        "yardage": 104
      },
      {
        "number": 13,
        "par": 4,
        "si": 2,
        "yardage": 265
      },
      {
        "number": 14,
        "par": 4,
        "si": 4,
        "yardage": 249
      },
      {
        "number": 15,
        "par": 3,
        "si": 10,
        "yardage": 105
      },
      {
        "number": 16,
        "par": 5,
        "si": 12,
        "yardage": 415
      },
      {
        "number": 17,
        "par": 3,
        "si": 8,
        "yardage": 82
      },
      {
        "number": 18,
        "par": 5,
        "si": 16,
        "yardage": 421
      }
    ],
    "tees": [
      {
        "id": "island-central-blue",
        "name": "Island/Central - Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 120,
        "rating": 66.8
      },
      {
        "id": "south-island-blue",
        "name": "South/Island - Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 121,
        "rating": 65.8
      },
      {
        "id": "central-south-blue",
        "name": "Central/South - Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 120,
        "rating": 66.2
      },
      {
        "id": "island-central-white",
        "name": "Island/Central - White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 114,
        "rating": 64.8
      },
      {
        "id": "central-south-white",
        "name": "Central/South - White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 115,
        "rating": 64.3
      },
      {
        "id": "south-island-white",
        "name": "South/Island - White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 114,
        "rating": 64.1
      },
      {
        "id": "island-central-red",
        "name": "Island/Central - Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 101,
        "rating": 61.5
      },
      {
        "id": "central-south-red",
        "name": "Central/South - Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 103,
        "rating": 61.1
      },
      {
        "id": "south-island-red",
        "name": "South/Island - Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 100,
        "rating": 61.2
      }
    ]
  },
  {
    "id": "gl_ponderosa-golf-and-country-club",
    "name": "Ponderosa Golf And Country Club",
    "city": "Beeton",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 3,
        "si": 13,
        "yardage": 116
      },
      {
        "number": 2,
        "par": 4,
        "si": 7,
        "yardage": 241
      },
      {
        "number": 3,
        "par": 4,
        "si": 3,
        "yardage": 328
      },
      {
        "number": 4,
        "par": 4,
        "si": 11,
        "yardage": 262
      },
      {
        "number": 5,
        "par": 4,
        "si": 1,
        "yardage": 406
      },
      {
        "number": 6,
        "par": 3,
        "si": 5,
        "yardage": 217
      },
      {
        "number": 7,
        "par": 4,
        "si": 17,
        "yardage": 227
      },
      {
        "number": 8,
        "par": 3,
        "si": 15,
        "yardage": 123
      },
      {
        "number": 9,
        "par": 3,
        "si": 9,
        "yardage": 224
      }
    ]
  },
  {
    "id": "gl_big-bay-point-golf-and-country-club",
    "name": "Big Bay Point Golf And Country Club",
    "city": "Innisfil",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 375
      },
      {
        "number": 2,
        "par": 4,
        "si": 5,
        "yardage": 340
      },
      {
        "number": 3,
        "par": 4,
        "si": 11,
        "yardage": 271
      },
      {
        "number": 4,
        "par": 3,
        "si": 13,
        "yardage": 149
      },
      {
        "number": 5,
        "par": 4,
        "si": 9,
        "yardage": 267
      },
      {
        "number": 6,
        "par": 3,
        "si": 15,
        "yardage": 132
      },
      {
        "number": 7,
        "par": 4,
        "si": 7,
        "yardage": 295
      },
      {
        "number": 8,
        "par": 3,
        "si": 17,
        "yardage": 97
      },
      {
        "number": 9,
        "par": 4,
        "si": 3,
        "yardage": 362
      }
    ],
    "tees": [
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 112,
        "rating": 31.2
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 111,
        "rating": 30.9
      }
    ]
  },
  {
    "id": "gl_big-cedar-golf-country-club",
    "name": "Big Cedar Golf Country Club",
    "city": "Innisfil",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 346
      },
      {
        "number": 2,
        "par": 5,
        "si": 3,
        "yardage": 431
      },
      {
        "number": 3,
        "par": 3,
        "si": 15,
        "yardage": 171
      },
      {
        "number": 4,
        "par": 3,
        "si": 17,
        "yardage": 137
      },
      {
        "number": 5,
        "par": 4,
        "si": 13,
        "yardage": 310
      },
      {
        "number": 6,
        "par": 4,
        "si": 9,
        "yardage": 354
      },
      {
        "number": 7,
        "par": 4,
        "si": 11,
        "yardage": 243
      },
      {
        "number": 8,
        "par": 4,
        "si": 7,
        "yardage": 325
      },
      {
        "number": 9,
        "par": 4,
        "si": 5,
        "yardage": 340
      }
    ],
    "tees": [
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 107,
        "rating": 32.6
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 107,
        "rating": 32.5
      }
    ]
  },
  {
    "id": "gl_blue-mountain-golf-and-country-club",
    "name": "Blue Mountain Golf And Country Club",
    "city": "Collingwood",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 4,
        "yardage": 300
      },
      {
        "number": 2,
        "par": 4,
        "si": 12,
        "yardage": 249
      },
      {
        "number": 3,
        "par": 5,
        "si": 2,
        "yardage": 390
      },
      {
        "number": 4,
        "par": 5,
        "si": 6,
        "yardage": 405
      },
      {
        "number": 5,
        "par": 4,
        "si": 8,
        "yardage": 216
      },
      {
        "number": 6,
        "par": 3,
        "si": 16,
        "yardage": 116
      },
      {
        "number": 7,
        "par": 4,
        "si": 14,
        "yardage": 247
      },
      {
        "number": 8,
        "par": 3,
        "si": 18,
        "yardage": 98
      },
      {
        "number": 9,
        "par": 5,
        "si": 10,
        "yardage": 400
      },
      {
        "number": 10,
        "par": 4,
        "si": 5,
        "yardage": 233
      },
      {
        "number": 11,
        "par": 3,
        "si": 17,
        "yardage": 87
      },
      {
        "number": 12,
        "par": 4,
        "si": 7,
        "yardage": 200
      },
      {
        "number": 13,
        "par": 5,
        "si": 1,
        "yardage": 355
      },
      {
        "number": 14,
        "par": 3,
        "si": 9,
        "yardage": 70
      },
      {
        "number": 15,
        "par": 4,
        "si": 3,
        "yardage": 300
      },
      {
        "number": 16,
        "par": 4,
        "si": 13,
        "yardage": 231
      },
      {
        "number": 17,
        "par": 3,
        "si": 15,
        "yardage": 101
      },
      {
        "number": 18,
        "par": 5,
        "si": 11,
        "yardage": 385
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 135,
        "rating": 71.2
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 126,
        "rating": 70.1
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 119,
        "rating": 67.2
      },
      {
        "id": "long-hybrid",
        "name": "Long Hybrid",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 122,
        "rating": 68.7
      },
      {
        "id": "short-hybrid",
        "name": "Short Hybrid",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 115,
        "rating": 65.5
      },
      {
        "id": "yellow",
        "name": "Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 100,
        "rating": 62.8
      }
    ]
  },
  {
    "id": "gl_bonaire-golf-and-country-club",
    "name": "Bonaire Golf And Country Club",
    "city": "Coldwater",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 376
      },
      {
        "number": 2,
        "par": 3,
        "si": 15,
        "yardage": 122
      },
      {
        "number": 3,
        "par": 4,
        "si": 17,
        "yardage": 292
      },
      {
        "number": 4,
        "par": 4,
        "si": 5,
        "yardage": 288
      },
      {
        "number": 5,
        "par": 5,
        "si": 13,
        "yardage": 402
      },
      {
        "number": 6,
        "par": 4,
        "si": 3,
        "yardage": 242
      },
      {
        "number": 7,
        "par": 4,
        "si": 7,
        "yardage": 320
      },
      {
        "number": 8,
        "par": 4,
        "si": 11,
        "yardage": 272
      },
      {
        "number": 9,
        "par": 3,
        "si": 9,
        "yardage": 161
      },
      {
        "number": 10,
        "par": 5,
        "si": 6,
        "yardage": 475
      },
      {
        "number": 11,
        "par": 4,
        "si": 18,
        "yardage": 340
      },
      {
        "number": 12,
        "par": 3,
        "si": 2,
        "yardage": 175
      },
      {
        "number": 13,
        "par": 4,
        "si": 14,
        "yardage": 315
      },
      {
        "number": 14,
        "par": 4,
        "si": 12,
        "yardage": 270
      },
      {
        "number": 15,
        "par": 3,
        "si": 10,
        "yardage": 124
      },
      {
        "number": 16,
        "par": 4,
        "si": 4,
        "yardage": 302
      },
      {
        "number": 17,
        "par": 4,
        "si": 8,
        "yardage": 295
      },
      {
        "number": 18,
        "par": 4,
        "si": 16,
        "yardage": 345
      }
    ]
  },
  {
    "id": "gl_cfb-borden-golf-club-circled-pine",
    "name": "Cfb Borden Golf Club Circled Pine",
    "city": "Borden",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 12,
        "yardage": 353
      },
      {
        "number": 2,
        "par": 4,
        "si": 14,
        "yardage": 311
      },
      {
        "number": 3,
        "par": 3,
        "si": 16,
        "yardage": 159
      },
      {
        "number": 4,
        "par": 4,
        "si": 6,
        "yardage": 389
      },
      {
        "number": 5,
        "par": 5,
        "si": 4,
        "yardage": 402
      },
      {
        "number": 6,
        "par": 5,
        "si": 2,
        "yardage": 416
      },
      {
        "number": 7,
        "par": 3,
        "si": 18,
        "yardage": 100
      },
      {
        "number": 8,
        "par": 4,
        "si": 8,
        "yardage": 328
      },
      {
        "number": 9,
        "par": 4,
        "si": 10,
        "yardage": 313
      },
      {
        "number": 10,
        "par": 4,
        "si": 7,
        "yardage": 300
      },
      {
        "number": 11,
        "par": 3,
        "si": 17,
        "yardage": 130
      },
      {
        "number": 12,
        "par": 5,
        "si": 9,
        "yardage": 414
      },
      {
        "number": 13,
        "par": 4,
        "si": 3,
        "yardage": 289
      },
      {
        "number": 14,
        "par": 4,
        "si": 13,
        "yardage": 324
      },
      {
        "number": 15,
        "par": 4,
        "si": 1,
        "yardage": 349
      },
      {
        "number": 16,
        "par": 5,
        "si": 11,
        "yardage": 414
      },
      {
        "number": 17,
        "par": 3,
        "si": 15,
        "yardage": 158
      },
      {
        "number": 18,
        "par": 5,
        "si": 5,
        "yardage": 341
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 127,
        "rating": 71.2
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 123,
        "rating": 69.9
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 121,
        "rating": 72.8
      }
    ]
  },
  {
    "id": "gl_orillia-golf-and-country-club",
    "name": "Orillia Golf And Country Club",
    "city": "Orillia",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 5,
        "yardage": 344
      },
      {
        "number": 2,
        "par": 4,
        "si": 11,
        "yardage": 283
      },
      {
        "number": 3,
        "par": 4,
        "si": 15,
        "yardage": 301
      },
      {
        "number": 4,
        "par": 3,
        "si": 7,
        "yardage": 93
      },
      {
        "number": 5,
        "par": 5,
        "si": 17,
        "yardage": 367
      },
      {
        "number": 6,
        "par": 4,
        "si": 3,
        "yardage": 287
      },
      {
        "number": 7,
        "par": 3,
        "si": 9,
        "yardage": 136
      },
      {
        "number": 8,
        "par": 4,
        "si": 13,
        "yardage": 232
      },
      {
        "number": 9,
        "par": 5,
        "si": 1,
        "yardage": 348
      },
      {
        "number": 10,
        "par": 4,
        "si": 14,
        "yardage": 268
      },
      {
        "number": 11,
        "par": 4,
        "si": 12,
        "yardage": 338
      },
      {
        "number": 12,
        "par": 3,
        "si": 18,
        "yardage": 112
      },
      {
        "number": 13,
        "par": 4,
        "si": 8,
        "yardage": 360
      },
      {
        "number": 14,
        "par": 5,
        "si": 4,
        "yardage": 394
      },
      {
        "number": 15,
        "par": 3,
        "si": 6,
        "yardage": 147
      },
      {
        "number": 16,
        "par": 4,
        "si": 10,
        "yardage": 305
      },
      {
        "number": 17,
        "par": 4,
        "si": 2,
        "yardage": 321
      },
      {
        "number": 18,
        "par": 4,
        "si": 16,
        "yardage": 271
      }
    ],
    "tees": [
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 122,
        "rating": 69.6
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 119,
        "rating": 68.3
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 116,
        "rating": 66.9
      }
    ]
  },
  {
    "id": "gl_briars-golf-club",
    "name": "Briars Golf Club",
    "city": "Sutton West",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 4,
        "yardage": 372
      },
      {
        "number": 2,
        "par": 4,
        "si": 2,
        "yardage": 358
      },
      {
        "number": 3,
        "par": 3,
        "si": 10,
        "yardage": 125
      },
      {
        "number": 4,
        "par": 5,
        "si": 12,
        "yardage": 399
      },
      {
        "number": 5,
        "par": 3,
        "si": 18,
        "yardage": 85
      },
      {
        "number": 6,
        "par": 4,
        "si": 8,
        "yardage": 330
      },
      {
        "number": 7,
        "par": 4,
        "si": 14,
        "yardage": 323
      },
      {
        "number": 8,
        "par": 4,
        "si": 16,
        "yardage": 220
      },
      {
        "number": 9,
        "par": 5,
        "si": 6,
        "yardage": 417
      },
      {
        "number": 10,
        "par": 4,
        "si": 9,
        "yardage": 330
      },
      {
        "number": 11,
        "par": 4,
        "si": 13,
        "yardage": 294
      },
      {
        "number": 12,
        "par": 4,
        "si": 5,
        "yardage": 297
      },
      {
        "number": 13,
        "par": 3,
        "si": 17,
        "yardage": 86
      },
      {
        "number": 14,
        "par": 5,
        "si": 1,
        "yardage": 471
      },
      {
        "number": 15,
        "par": 4,
        "si": 11,
        "yardage": 306
      },
      {
        "number": 16,
        "par": 3,
        "si": 15,
        "yardage": 139
      },
      {
        "number": 17,
        "par": 4,
        "si": 3,
        "yardage": 306
      },
      {
        "number": 18,
        "par": 4,
        "si": 7,
        "yardage": 370
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 130,
        "rating": 70.8
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 128,
        "rating": 69.7
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 117,
        "rating": 66.8
      },
      {
        "id": "yellow",
        "name": "Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 114,
        "rating": 65.8
      }
    ]
  },
  {
    "id": "gl_brooklea-g-cc-18-hole-championship",
    "name": "Brooklea G Cc 18 Hole Championship",
    "city": "Midland",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 7,
        "yardage": 341
      },
      {
        "number": 2,
        "par": 4,
        "si": 5,
        "yardage": 355
      },
      {
        "number": 3,
        "par": 3,
        "si": 17,
        "yardage": 136
      },
      {
        "number": 4,
        "par": 4,
        "si": 13,
        "yardage": 286
      },
      {
        "number": 5,
        "par": 5,
        "si": 3,
        "yardage": 437
      },
      {
        "number": 6,
        "par": 4,
        "si": 11,
        "yardage": 311
      },
      {
        "number": 7,
        "par": 3,
        "si": 15,
        "yardage": 103
      },
      {
        "number": 8,
        "par": 5,
        "si": 1,
        "yardage": 452
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 345
      },
      {
        "number": 10,
        "par": 4,
        "si": 12,
        "yardage": 367
      },
      {
        "number": 11,
        "par": 4,
        "si": 14,
        "yardage": 278
      },
      {
        "number": 12,
        "par": 3,
        "si": 18,
        "yardage": 98
      },
      {
        "number": 13,
        "par": 4,
        "si": 10,
        "yardage": 347
      },
      {
        "number": 14,
        "par": 5,
        "si": 4,
        "yardage": 402
      },
      {
        "number": 15,
        "par": 5,
        "si": 2,
        "yardage": 416
      },
      {
        "number": 16,
        "par": 4,
        "si": 6,
        "yardage": 369
      },
      {
        "number": 17,
        "par": 3,
        "si": 16,
        "yardage": 16
      },
      {
        "number": 18,
        "par": 4,
        "si": 8,
        "yardage": 345
      }
    ]
  },
  {
    "id": "gl_brooklea-g-cc-9-hole-west",
    "name": "Brooklea G Cc 9 Hole West",
    "city": "Midland",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 3,
        "si": 11,
        "yardage": 140
      },
      {
        "number": 2,
        "par": 4,
        "si": 5,
        "yardage": 223
      },
      {
        "number": 3,
        "par": 4,
        "si": 7,
        "yardage": 231
      },
      {
        "number": 4,
        "par": 3,
        "si": 15,
        "yardage": 114
      },
      {
        "number": 5,
        "par": 4,
        "si": 3,
        "yardage": 217
      },
      {
        "number": 6,
        "par": 4,
        "si": 1,
        "yardage": 288
      },
      {
        "number": 7,
        "par": 3,
        "si": 13,
        "yardage": 120
      },
      {
        "number": 8,
        "par": 4,
        "si": 9,
        "yardage": 189
      },
      {
        "number": 9,
        "par": 3,
        "si": 17,
        "yardage": 87
      }
    ],
    "tees": [
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 99,
        "rating": 29.2
      }
    ]
  },
  {
    "id": "gl_caldeon-woods-golf-club",
    "name": "Caldeon Woods Golf Club",
    "city": "Bolton",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 3,
        "yardage": 335
      },
      {
        "number": 2,
        "par": 4,
        "si": 7,
        "yardage": 208
      },
      {
        "number": 3,
        "par": 3,
        "si": 13,
        "yardage": 140
      },
      {
        "number": 4,
        "par": 4,
        "si": 11,
        "yardage": 233
      },
      {
        "number": 5,
        "par": 3,
        "si": 17,
        "yardage": 110
      },
      {
        "number": 6,
        "par": 4,
        "si": 1,
        "yardage": 307
      },
      {
        "number": 7,
        "par": 4,
        "si": 9,
        "yardage": 243
      },
      {
        "number": 8,
        "par": 5,
        "si": 5,
        "yardage": 421
      },
      {
        "number": 9,
        "par": 4,
        "si": 15,
        "yardage": 303
      },
      {
        "number": 10,
        "par": 5,
        "si": 4,
        "yardage": 388
      },
      {
        "number": 11,
        "par": 3,
        "si": 14,
        "yardage": 125
      },
      {
        "number": 12,
        "par": 5,
        "si": 12,
        "yardage": 415
      },
      {
        "number": 13,
        "par": 3,
        "si": 18,
        "yardage": 110
      },
      {
        "number": 14,
        "par": 4,
        "si": 16,
        "yardage": 242
      },
      {
        "number": 15,
        "par": 4,
        "si": 8,
        "yardage": 220
      },
      {
        "number": 16,
        "par": 4,
        "si": 6,
        "yardage": 270
      },
      {
        "number": 17,
        "par": 4,
        "si": 2,
        "yardage": 290
      },
      {
        "number": 18,
        "par": 4,
        "si": 10,
        "yardage": 295
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 133,
        "rating": 70.8
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 127,
        "rating": 68.5
      },
      {
        "id": "green",
        "name": "Green",
        "color": "#047857",
        "colors": [
          "#047857"
        ],
        "slope": 117,
        "rating": 65.6
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 103,
        "rating": 63.5
      }
    ]
  },
  {
    "id": "gl_cardinal-golf-club-east",
    "name": "Cardinal Golf Club East",
    "city": "King",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 3,
        "yardage": 225
      },
      {
        "number": 2,
        "par": 3,
        "si": 11,
        "yardage": 71
      },
      {
        "number": 3,
        "par": 4,
        "si": 5,
        "yardage": 200
      },
      {
        "number": 4,
        "par": 4,
        "si": 7,
        "yardage": 200
      },
      {
        "number": 5,
        "par": 4,
        "si": 17,
        "yardage": 175
      },
      {
        "number": 6,
        "par": 4,
        "si": 13,
        "yardage": 100
      },
      {
        "number": 7,
        "par": 3,
        "si": 15,
        "yardage": 106
      },
      {
        "number": 8,
        "par": 5,
        "si": 1,
        "yardage": 250
      },
      {
        "number": 9,
        "par": 3,
        "si": 9,
        "yardage": 125
      },
      {
        "number": 10,
        "par": 5,
        "si": 4,
        "yardage": 250
      },
      {
        "number": 11,
        "par": 4,
        "si": 10,
        "yardage": 200
      },
      {
        "number": 12,
        "par": 5,
        "si": 12,
        "yardage": 250
      },
      {
        "number": 13,
        "par": 4,
        "si": 8,
        "yardage": 200
      },
      {
        "number": 14,
        "par": 4,
        "si": 18,
        "yardage": 200
      },
      {
        "number": 15,
        "par": 3,
        "si": 14,
        "yardage": 135
      },
      {
        "number": 16,
        "par": 4,
        "si": 16,
        "yardage": 200
      },
      {
        "number": 17,
        "par": 3,
        "si": 6,
        "yardage": 100
      },
      {
        "number": 18,
        "par": 4,
        "si": 2,
        "yardage": 200
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 120,
        "rating": 70.8
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 115,
        "rating": 69.2
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 109,
        "rating": 66.7
      }
    ]
  },
  {
    "id": "gl_cardinal-golf-club-kettle-creek",
    "name": "Cardinal Golf Club Kettle Creek",
    "city": "King",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 3,
        "yardage": 192
      },
      {
        "number": 2,
        "par": 3,
        "si": 13,
        "yardage": 87
      },
      {
        "number": 3,
        "par": 4,
        "si": 1,
        "yardage": 237
      },
      {
        "number": 4,
        "par": 3,
        "si": 11,
        "yardage": 95
      },
      {
        "number": 5,
        "par": 3,
        "si": 15,
        "yardage": 86
      },
      {
        "number": 6,
        "par": 3,
        "si": 17,
        "yardage": 65
      },
      {
        "number": 7,
        "par": 3,
        "si": 7,
        "yardage": 104
      },
      {
        "number": 8,
        "par": 3,
        "si": 9,
        "yardage": 95
      },
      {
        "number": 9,
        "par": 3,
        "si": 5,
        "yardage": 106
      },
      {
        "number": 10,
        "par": 4,
        "si": 4,
        "yardage": 202
      },
      {
        "number": 11,
        "par": 3,
        "si": 10,
        "yardage": 131
      },
      {
        "number": 12,
        "par": 3,
        "si": 18,
        "yardage": 92
      },
      {
        "number": 13,
        "par": 4,
        "si": 2,
        "yardage": 225
      },
      {
        "number": 14,
        "par": 3,
        "si": 8,
        "yardage": 141
      },
      {
        "number": 15,
        "par": 3,
        "si": 6,
        "yardage": 146
      },
      {
        "number": 16,
        "par": 3,
        "si": 16,
        "yardage": 97
      },
      {
        "number": 17,
        "par": 3,
        "si": 14,
        "yardage": 109
      },
      {
        "number": 18,
        "par": 3,
        "si": 12,
        "yardage": 116
      }
    ]
  },
  {
    "id": "gl_cardinal-golf-club-red-crest",
    "name": "Cardinal Golf Club Red Crest",
    "city": "King",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 6,
        "yardage": 200
      },
      {
        "number": 2,
        "par": 3,
        "si": 10,
        "yardage": 142
      },
      {
        "number": 3,
        "par": 4,
        "si": 16,
        "yardage": 200
      },
      {
        "number": 4,
        "par": 4,
        "si": 12,
        "yardage": 200
      },
      {
        "number": 5,
        "par": 4,
        "si": 14,
        "yardage": 175
      },
      {
        "number": 6,
        "par": 5,
        "si": 4,
        "yardage": 250
      },
      {
        "number": 7,
        "par": 5,
        "si": 2,
        "yardage": 250
      },
      {
        "number": 8,
        "par": 3,
        "si": 16,
        "yardage": 122
      },
      {
        "number": 9,
        "par": 4,
        "si": 8,
        "yardage": 175
      },
      {
        "number": 10,
        "par": 5,
        "si": 1,
        "yardage": 200
      },
      {
        "number": 11,
        "par": 4,
        "si": 11,
        "yardage": 200
      },
      {
        "number": 12,
        "par": 3,
        "si": 7,
        "yardage": 118
      },
      {
        "number": 13,
        "par": 4,
        "si": 17,
        "yardage": 175
      },
      {
        "number": 14,
        "par": 4,
        "si": 13,
        "yardage": 175
      },
      {
        "number": 15,
        "par": 4,
        "si": 15,
        "yardage": 200
      },
      {
        "number": 16,
        "par": 4,
        "si": 5,
        "yardage": 200
      },
      {
        "number": 17,
        "par": 3,
        "si": 9,
        "yardage": 159
      },
      {
        "number": 18,
        "par": 4,
        "si": 3,
        "yardage": 200
      }
    ],
    "tees": [
      {
        "id": "backred",
        "name": "BackRed",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 134,
        "rating": 71.8
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 131,
        "rating": 70.4
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 128,
        "rating": 68.8
      },
      {
        "id": "yellow",
        "name": "Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 114,
        "rating": 65.2
      }
    ]
  },
  {
    "id": "gl_cardinal-golf-club-west",
    "name": "Cardinal Golf Club West",
    "city": "King",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 11,
        "yardage": 200
      },
      {
        "number": 2,
        "par": 4,
        "si": 5,
        "yardage": 175
      },
      {
        "number": 3,
        "par": 5,
        "si": 7,
        "yardage": 225
      },
      {
        "number": 4,
        "par": 4,
        "si": 9,
        "yardage": 200
      },
      {
        "number": 5,
        "par": 3,
        "si": 13,
        "yardage": 120
      },
      {
        "number": 6,
        "par": 4,
        "si": 1,
        "yardage": 200
      },
      {
        "number": 7,
        "par": 4,
        "si": 3,
        "yardage": 175
      },
      {
        "number": 8,
        "par": 3,
        "si": 15,
        "yardage": 85
      },
      {
        "number": 9,
        "par": 4,
        "si": 17,
        "yardage": 200
      },
      {
        "number": 10,
        "par": 4,
        "si": 12,
        "yardage": 200
      },
      {
        "number": 11,
        "par": 3,
        "si": 16,
        "yardage": 115
      },
      {
        "number": 12,
        "par": 4,
        "si": 2,
        "yardage": 175
      },
      {
        "number": 13,
        "par": 5,
        "si": 8,
        "yardage": 250
      },
      {
        "number": 14,
        "par": 3,
        "si": 18,
        "yardage": 120
      },
      {
        "number": 15,
        "par": 5,
        "si": 4,
        "yardage": 250
      },
      {
        "number": 16,
        "par": 3,
        "si": 14,
        "yardage": 120
      },
      {
        "number": 17,
        "par": 4,
        "si": 10,
        "yardage": 175
      },
      {
        "number": 18,
        "par": 5,
        "si": 6,
        "yardage": 250
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 127,
        "rating": 70.6
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 121,
        "rating": 68.4
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 108,
        "rating": 64.7
      }
    ]
  },
  {
    "id": "gl_carrying-place-g-cc",
    "name": "Carrying Place G Cc",
    "city": "King",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 15,
        "yardage": 250
      },
      {
        "number": 2,
        "par": 4,
        "si": 9,
        "yardage": 285
      },
      {
        "number": 3,
        "par": 4,
        "si": 3,
        "yardage": 350
      },
      {
        "number": 4,
        "par": 3,
        "si": 17,
        "yardage": 100
      },
      {
        "number": 5,
        "par": 4,
        "si": 1,
        "yardage": 366
      },
      {
        "number": 6,
        "par": 4,
        "si": 11,
        "yardage": 260
      },
      {
        "number": 7,
        "par": 3,
        "si": 13,
        "yardage": 135
      },
      {
        "number": 8,
        "par": 5,
        "si": 5,
        "yardage": 415
      },
      {
        "number": 9,
        "par": 4,
        "si": 7,
        "yardage": 270
      },
      {
        "number": 10,
        "par": 3,
        "si": 8,
        "yardage": 148
      },
      {
        "number": 11,
        "par": 4,
        "si": 2,
        "yardage": 340
      },
      {
        "number": 12,
        "par": 3,
        "si": 16,
        "yardage": 132
      },
      {
        "number": 13,
        "par": 5,
        "si": 6,
        "yardage": 424
      },
      {
        "number": 14,
        "par": 4,
        "si": 18,
        "yardage": 250
      },
      {
        "number": 15,
        "par": 4,
        "si": 14,
        "yardage": 290
      },
      {
        "number": 16,
        "par": 4,
        "si": 10,
        "yardage": 300
      },
      {
        "number": 17,
        "par": 4,
        "si": 12,
        "yardage": 310
      },
      {
        "number": 18,
        "par": 4,
        "si": 4,
        "yardage": 306
      }
    ],
    "tees": [
      {
        "id": "back",
        "name": "Back",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 134,
        "rating": 70.2
      },
      {
        "id": "middle",
        "name": "Middle",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 128,
        "rating": 68
      },
      {
        "id": "front",
        "name": "Front",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 110,
        "rating": 63.9
      }
    ]
  },
  {
    "id": "gl_cedar-links-golf-club--2",
    "name": "Cedar Links Golf Club",
    "city": "Barrie",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 3,
        "si": 1,
        "yardage": 97
      },
      {
        "number": 2,
        "par": 3,
        "si": 2,
        "yardage": 89
      },
      {
        "number": 3,
        "par": 3,
        "si": 3,
        "yardage": 140
      },
      {
        "number": 4,
        "par": 3,
        "si": 4,
        "yardage": 143
      },
      {
        "number": 5,
        "par": 3,
        "si": 5,
        "yardage": 87
      },
      {
        "number": 6,
        "par": 3,
        "si": 6,
        "yardage": 110
      },
      {
        "number": 7,
        "par": 3,
        "si": 7,
        "yardage": 115
      },
      {
        "number": 8,
        "par": 3,
        "si": 8,
        "yardage": 86
      },
      {
        "number": 9,
        "par": 3,
        "si": 9,
        "yardage": 112
      }
    ]
  },
  {
    "id": "gl_chesley-lake-camp-golf-course",
    "name": "Chesley Lake Camp Golf Course",
    "city": "Allenford",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 280
      },
      {
        "number": 2,
        "par": 4,
        "si": 2,
        "yardage": 304
      },
      {
        "number": 3,
        "par": 3,
        "si": 3,
        "yardage": 140
      },
      {
        "number": 4,
        "par": 3,
        "si": 4,
        "yardage": 129
      },
      {
        "number": 5,
        "par": 4,
        "si": 5,
        "yardage": 303
      },
      {
        "number": 6,
        "par": 3,
        "si": 6,
        "yardage": 90
      },
      {
        "number": 7,
        "par": 5,
        "si": 7,
        "yardage": 390
      },
      {
        "number": 8,
        "par": 5,
        "si": 8,
        "yardage": 339
      },
      {
        "number": 9,
        "par": 3,
        "si": 9,
        "yardage": 121
      }
    ]
  },
  {
    "id": "gl_cobble-beach-golf-links",
    "name": "Cobble Beach Golf Links",
    "city": "Kemble",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 14,
        "yardage": 292
      },
      {
        "number": 2,
        "par": 4,
        "si": 12,
        "yardage": 257
      },
      {
        "number": 3,
        "par": 4,
        "si": 8,
        "yardage": 338
      },
      {
        "number": 4,
        "par": 4,
        "si": 16,
        "yardage": 255
      },
      {
        "number": 5,
        "par": 4,
        "si": 2,
        "yardage": 384
      },
      {
        "number": 6,
        "par": 3,
        "si": 10,
        "yardage": 115
      },
      {
        "number": 7,
        "par": 5,
        "si": 6,
        "yardage": 466
      },
      {
        "number": 8,
        "par": 3,
        "si": 18,
        "yardage": 98
      },
      {
        "number": 9,
        "par": 5,
        "si": 4,
        "yardage": 443
      },
      {
        "number": 10,
        "par": 4,
        "si": 3,
        "yardage": 341
      },
      {
        "number": 11,
        "par": 4,
        "si": 9,
        "yardage": 278
      },
      {
        "number": 12,
        "par": 5,
        "si": 5,
        "yardage": 443
      },
      {
        "number": 13,
        "par": 4,
        "si": 1,
        "yardage": 336
      },
      {
        "number": 14,
        "par": 3,
        "si": 15,
        "yardage": 117
      },
      {
        "number": 15,
        "par": 4,
        "si": 17,
        "yardage": 233
      },
      {
        "number": 16,
        "par": 4,
        "si": 11,
        "yardage": 271
      },
      {
        "number": 17,
        "par": 3,
        "si": 13,
        "yardage": 107
      },
      {
        "number": 18,
        "par": 5,
        "si": 7,
        "yardage": 436
      }
    ],
    "tees": [
      {
        "id": "championship",
        "name": "Championship",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 135,
        "rating": 73.6
      },
      {
        "id": "forward",
        "name": "Forward",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 111,
        "rating": 68.2
      }
    ]
  },
  {
    "id": "gl_couchiching-golf-and-country-club",
    "name": "Couchiching Golf And Country Club",
    "city": "Orillia",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 3,
        "yardage": 370
      },
      {
        "number": 2,
        "par": 4,
        "si": 9,
        "yardage": 259
      },
      {
        "number": 3,
        "par": 5,
        "si": 1,
        "yardage": 477
      },
      {
        "number": 4,
        "par": 3,
        "si": 15,
        "yardage": 135
      },
      {
        "number": 5,
        "par": 4,
        "si": 5,
        "yardage": 390
      },
      {
        "number": 6,
        "par": 3,
        "si": 17,
        "yardage": 118
      },
      {
        "number": 7,
        "par": 4,
        "si": 7,
        "yardage": 286
      },
      {
        "number": 8,
        "par": 3,
        "si": 13,
        "yardage": 170
      },
      {
        "number": 9,
        "par": 4,
        "si": 11,
        "yardage": 269
      }
    ],
    "tees": [
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 115,
        "rating": 32.8
      },
      {
        "id": "yellow",
        "name": "Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 117,
        "rating": 34.7
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 115,
        "rating": 32.7
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 117,
        "rating": 34.7
      }
    ]
  },
  {
    "id": "gl_cranberry-golf-resort",
    "name": "Cranberry Golf Resort",
    "city": "Collingwood",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 15,
        "yardage": 310
      },
      {
        "number": 2,
        "par": 4,
        "si": 1,
        "yardage": 368
      },
      {
        "number": 3,
        "par": 4,
        "si": 5,
        "yardage": 352
      },
      {
        "number": 4,
        "par": 3,
        "si": 17,
        "yardage": 123
      },
      {
        "number": 5,
        "par": 5,
        "si": 7,
        "yardage": 432
      },
      {
        "number": 6,
        "par": 3,
        "si": 11,
        "yardage": 124
      },
      {
        "number": 7,
        "par": 4,
        "si": 13,
        "yardage": 287
      },
      {
        "number": 8,
        "par": 5,
        "si": 9,
        "yardage": 473
      },
      {
        "number": 9,
        "par": 4,
        "si": 3,
        "yardage": 358
      },
      {
        "number": 10,
        "par": 5,
        "si": 4,
        "yardage": 451
      },
      {
        "number": 11,
        "par": 3,
        "si": 14,
        "yardage": 131
      },
      {
        "number": 12,
        "par": 4,
        "si": 12,
        "yardage": 262
      },
      {
        "number": 13,
        "par": 3,
        "si": 18,
        "yardage": 85
      },
      {
        "number": 14,
        "par": 4,
        "si": 10,
        "yardage": 326
      },
      {
        "number": 15,
        "par": 4,
        "si": 6,
        "yardage": 315
      },
      {
        "number": 16,
        "par": 5,
        "si": 2,
        "yardage": 379
      },
      {
        "number": 17,
        "par": 3,
        "si": 16,
        "yardage": 83
      },
      {
        "number": 18,
        "par": 5,
        "si": 8,
        "yardage": 447
      }
    ],
    "tees": [
      {
        "id": "backgold",
        "name": "BackGold",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 127,
        "rating": 71.7
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 123,
        "rating": 69.8
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 116,
        "rating": 68.2
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 110,
        "rating": 65.3
      }
    ]
  },
  {
    "id": "gl_devil-s-paintbrush",
    "name": "Devil S Paintbrush",
    "city": "Caledon East",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 7,
        "yardage": 300
      },
      {
        "number": 2,
        "par": 5,
        "si": 5,
        "yardage": 394
      },
      {
        "number": 3,
        "par": 4,
        "si": 13,
        "yardage": 201
      },
      {
        "number": 4,
        "par": 3,
        "si": 15,
        "yardage": 127
      },
      {
        "number": 5,
        "par": 4,
        "si": 9,
        "yardage": 315
      },
      {
        "number": 6,
        "par": 4,
        "si": 1,
        "yardage": 315
      },
      {
        "number": 7,
        "par": 3,
        "si": 17,
        "yardage": 117
      },
      {
        "number": 8,
        "par": 5,
        "si": 3,
        "yardage": 461
      },
      {
        "number": 9,
        "par": 4,
        "si": 11,
        "yardage": 325
      },
      {
        "number": 10,
        "par": 4,
        "si": 10,
        "yardage": 262
      },
      {
        "number": 11,
        "par": 5,
        "si": 2,
        "yardage": 446
      },
      {
        "number": 12,
        "par": 4,
        "si": 4,
        "yardage": 333
      },
      {
        "number": 13,
        "par": 3,
        "si": 16,
        "yardage": 137
      },
      {
        "number": 14,
        "par": 5,
        "si": 6,
        "yardage": 454
      },
      {
        "number": 15,
        "par": 4,
        "si": 12,
        "yardage": 304
      },
      {
        "number": 16,
        "par": 3,
        "si": 18,
        "yardage": 129
      },
      {
        "number": 17,
        "par": 4,
        "si": 14,
        "yardage": 264
      },
      {
        "number": 18,
        "par": 4,
        "si": 8,
        "yardage": 317
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 131,
        "rating": 71.8
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 127,
        "rating": 70.3
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 123,
        "rating": 68.5
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 107,
        "rating": 65.1
      }
    ]
  },
  {
    "id": "gl_devil-s-pulpit",
    "name": "Devil S Pulpit",
    "city": "Caledon Village",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 11,
        "yardage": 419
      },
      {
        "number": 2,
        "par": 4,
        "si": 13,
        "yardage": 268
      },
      {
        "number": 3,
        "par": 3,
        "si": 15,
        "yardage": 138
      },
      {
        "number": 4,
        "par": 4,
        "si": 1,
        "yardage": 331
      },
      {
        "number": 5,
        "par": 4,
        "si": 5,
        "yardage": 350
      },
      {
        "number": 6,
        "par": 4,
        "si": 7,
        "yardage": 331
      },
      {
        "number": 7,
        "par": 3,
        "si": 17,
        "yardage": 110
      },
      {
        "number": 8,
        "par": 5,
        "si": 3,
        "yardage": 393
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 298
      },
      {
        "number": 10,
        "par": 4,
        "si": 14,
        "yardage": 333
      },
      {
        "number": 11,
        "par": 4,
        "si": 16,
        "yardage": 297
      },
      {
        "number": 12,
        "par": 4,
        "si": 8,
        "yardage": 305
      },
      {
        "number": 13,
        "par": 5,
        "si": 2,
        "yardage": 413
      },
      {
        "number": 14,
        "par": 4,
        "si": 6,
        "yardage": 276
      },
      {
        "number": 15,
        "par": 4,
        "si": 10,
        "yardage": 285
      },
      {
        "number": 16,
        "par": 3,
        "si": 18,
        "yardage": 119
      },
      {
        "number": 17,
        "par": 4,
        "si": 4,
        "yardage": 293
      },
      {
        "number": 18,
        "par": 4,
        "si": 12,
        "yardage": 463
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 137,
        "rating": 74.5
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 135,
        "rating": 72.3
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 127,
        "rating": 69.2
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 126,
        "rating": 71.5
      }
    ]
  },
  {
    "id": "gl_dufferin-glen-golf-club",
    "name": "Dufferin Glen Golf Club",
    "city": "Mono",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 236
      },
      {
        "number": 2,
        "par": 3,
        "si": 2,
        "yardage": 94
      },
      {
        "number": 3,
        "par": 3,
        "si": 3,
        "yardage": 104
      },
      {
        "number": 4,
        "par": 4,
        "si": 4,
        "yardage": 237
      },
      {
        "number": 5,
        "par": 3,
        "si": 5,
        "yardage": 91
      },
      {
        "number": 6,
        "par": 4,
        "si": 6,
        "yardage": 240
      },
      {
        "number": 7,
        "par": 3,
        "si": 7,
        "yardage": 112
      },
      {
        "number": 8,
        "par": 4,
        "si": 8,
        "yardage": 195
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 261
      }
    ]
  },
  {
    "id": "gl_dunadel-golf-association",
    "name": "Dunadel Golf Association",
    "city": "Dundalk",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 296
      },
      {
        "number": 2,
        "par": 3,
        "si": 2,
        "yardage": 160
      },
      {
        "number": 3,
        "par": 4,
        "si": 3,
        "yardage": 300
      },
      {
        "number": 4,
        "par": 4,
        "si": 4,
        "yardage": 297
      },
      {
        "number": 5,
        "par": 5,
        "si": 5,
        "yardage": 468
      },
      {
        "number": 6,
        "par": 4,
        "si": 6,
        "yardage": 302
      },
      {
        "number": 7,
        "par": 5,
        "si": 7,
        "yardage": 384
      },
      {
        "number": 8,
        "par": 3,
        "si": 8,
        "yardage": 155
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 312
      }
    ]
  },
  {
    "id": "gl_duntroon-highlands-golf-club",
    "name": "Duntroon Highlands Golf Club",
    "city": "Duntroon",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 2,
        "yardage": 400
      },
      {
        "number": 2,
        "par": 4,
        "si": 12,
        "yardage": 315
      },
      {
        "number": 3,
        "par": 3,
        "si": 18,
        "yardage": 95
      },
      {
        "number": 4,
        "par": 4,
        "si": 10,
        "yardage": 308
      },
      {
        "number": 5,
        "par": 4,
        "si": 4,
        "yardage": 313
      },
      {
        "number": 6,
        "par": 4,
        "si": 16,
        "yardage": 312
      },
      {
        "number": 7,
        "par": 4,
        "si": 6,
        "yardage": 309
      },
      {
        "number": 8,
        "par": 3,
        "si": 14,
        "yardage": 134
      },
      {
        "number": 9,
        "par": 4,
        "si": 8,
        "yardage": 326
      },
      {
        "number": 10,
        "par": 5,
        "si": 5,
        "yardage": 446
      },
      {
        "number": 11,
        "par": 4,
        "si": 7,
        "yardage": 258
      },
      {
        "number": 12,
        "par": 4,
        "si": 11,
        "yardage": 269
      },
      {
        "number": 13,
        "par": 3,
        "si": 15,
        "yardage": 147
      },
      {
        "number": 14,
        "par": 3,
        "si": 13,
        "yardage": 184
      },
      {
        "number": 15,
        "par": 5,
        "si": 1,
        "yardage": 392
      },
      {
        "number": 16,
        "par": 4,
        "si": 17,
        "yardage": 238
      },
      {
        "number": 17,
        "par": 4,
        "si": 3,
        "yardage": 372
      },
      {
        "number": 18,
        "par": 4,
        "si": 9,
        "yardage": 310
      }
    ],
    "tees": [
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 122,
        "rating": 67.3
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 107,
        "rating": 63.8
      }
    ]
  },
  {
    "id": "gl_eastbourne-golf-club",
    "name": "Eastbourne Golf Club",
    "city": "Keswick",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 252
      },
      {
        "number": 2,
        "par": 3,
        "si": 2,
        "yardage": 207
      },
      {
        "number": 3,
        "par": 4,
        "si": 3,
        "yardage": 352
      },
      {
        "number": 4,
        "par": 3,
        "si": 4,
        "yardage": 216
      },
      {
        "number": 5,
        "par": 5,
        "si": 5,
        "yardage": 485
      },
      {
        "number": 6,
        "par": 4,
        "si": 6,
        "yardage": 347
      },
      {
        "number": 7,
        "par": 3,
        "si": 7,
        "yardage": 142
      },
      {
        "number": 8,
        "par": 4,
        "si": 8,
        "yardage": 270
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 267
      }
    ],
    "tees": [
      {
        "id": "back",
        "name": "Back",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 114,
        "rating": 32.6
      },
      {
        "id": "front",
        "name": "Front",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 107,
        "rating": 31.5
      }
    ]
  },
  {
    "id": "gl_evergreen-golf-centre--2",
    "name": "Evergreen Golf Centre",
    "city": "Washago",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 3,
        "si": 1,
        "yardage": 178
      },
      {
        "number": 2,
        "par": 3,
        "si": 2,
        "yardage": 130
      },
      {
        "number": 3,
        "par": 3,
        "si": 3,
        "yardage": 115
      },
      {
        "number": 4,
        "par": 3,
        "si": 4,
        "yardage": 100
      },
      {
        "number": 5,
        "par": 3,
        "si": 5,
        "yardage": 132
      },
      {
        "number": 6,
        "par": 3,
        "si": 6,
        "yardage": 145
      },
      {
        "number": 7,
        "par": 3,
        "si": 7,
        "yardage": 130
      },
      {
        "number": 8,
        "par": 3,
        "si": 8,
        "yardage": 190
      },
      {
        "number": 9,
        "par": 3,
        "si": 9,
        "yardage": 85
      }
    ]
  },
  {
    "id": "gl_glen-eagle-golf-club--2",
    "name": "Glen Eagle Golf Club",
    "city": "Caledon",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 1,
        "yardage": 454
      },
      {
        "number": 2,
        "par": 3,
        "si": 2,
        "yardage": 131
      },
      {
        "number": 3,
        "par": 4,
        "si": 3,
        "yardage": 273
      },
      {
        "number": 4,
        "par": 5,
        "si": 4,
        "yardage": 467
      },
      {
        "number": 5,
        "par": 4,
        "si": 5,
        "yardage": 278
      },
      {
        "number": 6,
        "par": 3,
        "si": 6,
        "yardage": 134
      },
      {
        "number": 7,
        "par": 4,
        "si": 7,
        "yardage": 304
      },
      {
        "number": 8,
        "par": 4,
        "si": 8,
        "yardage": 370
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 316
      },
      {
        "number": 10,
        "par": 4,
        "si": 10,
        "yardage": 337
      },
      {
        "number": 11,
        "par": 5,
        "si": 11,
        "yardage": 467
      },
      {
        "number": 12,
        "par": 3,
        "si": 12,
        "yardage": 138
      },
      {
        "number": 13,
        "par": 4,
        "si": 13,
        "yardage": 337
      },
      {
        "number": 14,
        "par": 5,
        "si": 14,
        "yardage": 427
      },
      {
        "number": 15,
        "par": 3,
        "si": 15,
        "yardage": 127
      },
      {
        "number": 16,
        "par": 5,
        "si": 16,
        "yardage": 423
      },
      {
        "number": 17,
        "par": 3,
        "si": 17,
        "yardage": 176
      },
      {
        "number": 18,
        "par": 4,
        "si": 18,
        "yardage": 279
      }
    ],
    "tees": [
      {
        "id": "blue-red-golds",
        "name": "Blue/Red - Golds",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 128,
        "rating": 73.8
      },
      {
        "id": "red-yellow-golds",
        "name": "Red/Yellow - Golds",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 133,
        "rating": 72.8
      },
      {
        "id": "yellow-blue-golds",
        "name": "Yellow/Blue - Golds",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 128,
        "rating": 72
      },
      {
        "id": "blue-red-blues",
        "name": "Blue/Red - Blues",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 123,
        "rating": 70.7
      },
      {
        "id": "red-yellow-blues",
        "name": "Red/Yellow - Blues",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 128,
        "rating": 70.4
      },
      {
        "id": "yellow-blue-blues",
        "name": "Yellow/Blue - Blues",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 123,
        "rating": 69.4
      },
      {
        "id": "blue-red-whites",
        "name": "Blue/Red - Whites",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 122,
        "rating": 70.1
      },
      {
        "id": "red-yellow-whites",
        "name": "Red/Yellow - Whites",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 126,
        "rating": 70.1
      },
      {
        "id": "yellow-blue-whites",
        "name": "Yellow/Blue - Whites",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 124,
        "rating": 69
      },
      {
        "id": "red-yellow-reds",
        "name": "Red/Yellow - Reds",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 120,
        "rating": 70.7
      },
      {
        "id": "blue-red-reds",
        "name": "Blue/Red - Reds",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 120,
        "rating": 70.7
      },
      {
        "id": "yellow-blue-reds",
        "name": "Yellow/Blue - Reds",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 120,
        "rating": 70.7
      }
    ]
  },
  {
    "id": "gl_harbour-view-golf-and-country-club",
    "name": "Harbour View Golf And Country Club",
    "city": "Gilford",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 9,
        "yardage": 318
      },
      {
        "number": 2,
        "par": 3,
        "si": 8,
        "yardage": 145
      },
      {
        "number": 3,
        "par": 5,
        "si": 6,
        "yardage": 397
      },
      {
        "number": 4,
        "par": 3,
        "si": 18,
        "yardage": 108
      },
      {
        "number": 5,
        "par": 5,
        "si": 3,
        "yardage": 470
      },
      {
        "number": 6,
        "par": 4,
        "si": 12,
        "yardage": 263
      },
      {
        "number": 7,
        "par": 4,
        "si": 10,
        "yardage": 322
      },
      {
        "number": 8,
        "par": 4,
        "si": 16,
        "yardage": 320
      },
      {
        "number": 9,
        "par": 4,
        "si": 1,
        "yardage": 318
      },
      {
        "number": 10,
        "par": 4,
        "si": 11,
        "yardage": 290
      },
      {
        "number": 11,
        "par": 3,
        "si": 13,
        "yardage": 123
      },
      {
        "number": 12,
        "par": 4,
        "si": 15,
        "yardage": 270
      },
      {
        "number": 13,
        "par": 4,
        "si": 7,
        "yardage": 300
      },
      {
        "number": 14,
        "par": 4,
        "si": 2,
        "yardage": 322
      },
      {
        "number": 15,
        "par": 3,
        "si": 17,
        "yardage": 141
      },
      {
        "number": 16,
        "par": 5,
        "si": 5,
        "yardage": 454
      },
      {
        "number": 17,
        "par": 4,
        "si": 4,
        "yardage": 290
      },
      {
        "number": 18,
        "par": 4,
        "si": 14,
        "yardage": 276
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 125,
        "rating": 64.9
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 122,
        "rating": 68.3
      },
      {
        "id": "yellow",
        "name": "Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 110,
        "rating": 65.1
      }
    ]
  },
  {
    "id": "gl_hawk-ridge-hawk-s-island",
    "name": "Hawk Ridge Hawk S Island",
    "city": "Severn",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 3,
        "si": 1,
        "yardage": 101
      },
      {
        "number": 2,
        "par": 3,
        "si": 2,
        "yardage": 116
      },
      {
        "number": 3,
        "par": 3,
        "si": 3,
        "yardage": 156
      },
      {
        "number": 4,
        "par": 3,
        "si": 4,
        "yardage": 86
      },
      {
        "number": 5,
        "par": 3,
        "si": 5,
        "yardage": 102
      },
      {
        "number": 6,
        "par": 3,
        "si": 6,
        "yardage": 116
      },
      {
        "number": 7,
        "par": 3,
        "si": 7,
        "yardage": 111
      },
      {
        "number": 8,
        "par": 3,
        "si": 8,
        "yardage": 120
      },
      {
        "number": 9,
        "par": 3,
        "si": 9,
        "yardage": 126
      }
    ],
    "tees": [
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 119,
        "rating": 27.7
      }
    ]
  },
  {
    "id": "gl_hawk-ridge-meadow-nest",
    "name": "Hawk Ridge Meadow Nest",
    "city": "Severn",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 9,
        "yardage": 348
      },
      {
        "number": 2,
        "par": 4,
        "si": 3,
        "yardage": 315
      },
      {
        "number": 3,
        "par": 5,
        "si": 13,
        "yardage": 458
      },
      {
        "number": 4,
        "par": 4,
        "si": 5,
        "yardage": 343
      },
      {
        "number": 5,
        "par": 4,
        "si": 11,
        "yardage": 337
      },
      {
        "number": 6,
        "par": 3,
        "si": 17,
        "yardage": 132
      },
      {
        "number": 7,
        "par": 5,
        "si": 15,
        "yardage": 430
      },
      {
        "number": 8,
        "par": 3,
        "si": 7,
        "yardage": 148
      },
      {
        "number": 9,
        "par": 4,
        "si": 1,
        "yardage": 332
      },
      {
        "number": 10,
        "par": 5,
        "si": 12,
        "yardage": 389
      },
      {
        "number": 11,
        "par": 4,
        "si": 6,
        "yardage": 296
      },
      {
        "number": 12,
        "par": 4,
        "si": 16,
        "yardage": 238
      },
      {
        "number": 13,
        "par": 3,
        "si": 18,
        "yardage": 113
      },
      {
        "number": 14,
        "par": 4,
        "si": 4,
        "yardage": 313
      },
      {
        "number": 15,
        "par": 4,
        "si": 8,
        "yardage": 281
      },
      {
        "number": 16,
        "par": 4,
        "si": 2,
        "yardage": 306
      },
      {
        "number": 17,
        "par": 3,
        "si": 14,
        "yardage": 125
      },
      {
        "number": 18,
        "par": 5,
        "si": 10,
        "yardage": 422
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 133,
        "rating": 72.6
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 129,
        "rating": 70.7
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 124,
        "rating": 69.1
      },
      {
        "id": "yellow",
        "name": "Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 115,
        "rating": 65.7
      }
    ]
  },
  {
    "id": "gl_hawk-ridge-timber-ridge",
    "name": "Hawk Ridge Timber Ridge",
    "city": "Severn",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 11,
        "yardage": 320
      },
      {
        "number": 2,
        "par": 4,
        "si": 17,
        "yardage": 315
      },
      {
        "number": 3,
        "par": 3,
        "si": 9,
        "yardage": 110
      },
      {
        "number": 4,
        "par": 5,
        "si": 1,
        "yardage": 433
      },
      {
        "number": 5,
        "par": 4,
        "si": 13,
        "yardage": 301
      },
      {
        "number": 6,
        "par": 4,
        "si": 5,
        "yardage": 291
      },
      {
        "number": 7,
        "par": 4,
        "si": 7,
        "yardage": 265
      },
      {
        "number": 8,
        "par": 3,
        "si": 15,
        "yardage": 81
      },
      {
        "number": 9,
        "par": 5,
        "si": 3,
        "yardage": 420
      },
      {
        "number": 10,
        "par": 4,
        "si": 6,
        "yardage": 341
      },
      {
        "number": 11,
        "par": 5,
        "si": 2,
        "yardage": 402
      },
      {
        "number": 12,
        "par": 3,
        "si": 12,
        "yardage": 120
      },
      {
        "number": 13,
        "par": 4,
        "si": 16,
        "yardage": 345
      },
      {
        "number": 14,
        "par": 3,
        "si": 8,
        "yardage": 79
      },
      {
        "number": 15,
        "par": 5,
        "si": 4,
        "yardage": 428
      },
      {
        "number": 16,
        "par": 3,
        "si": 18,
        "yardage": 102
      },
      {
        "number": 17,
        "par": 4,
        "si": 14,
        "yardage": 302
      },
      {
        "number": 18,
        "par": 4,
        "si": 10,
        "yardage": 330
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 131,
        "rating": 71.9
      },
      {
        "id": "yellow",
        "name": "Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 113,
        "rating": 70.2
      }
    ]
  },
  {
    "id": "gl_heritage-hills-golf-club",
    "name": "Heritage Hills Golf Club",
    "city": "Shanty Bay",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 8,
        "yardage": 325
      },
      {
        "number": 2,
        "par": 4,
        "si": 14,
        "yardage": 290
      },
      {
        "number": 3,
        "par": 3,
        "si": 12,
        "yardage": 163
      },
      {
        "number": 4,
        "par": 4,
        "si": 16,
        "yardage": 261
      },
      {
        "number": 5,
        "par": 5,
        "si": 4,
        "yardage": 415
      },
      {
        "number": 6,
        "par": 3,
        "si": 18,
        "yardage": 134
      },
      {
        "number": 7,
        "par": 4,
        "si": 6,
        "yardage": 295
      },
      {
        "number": 8,
        "par": 5,
        "si": 2,
        "yardage": 418
      },
      {
        "number": 9,
        "par": 4,
        "si": 10,
        "yardage": 325
      },
      {
        "number": 10,
        "par": 4,
        "si": 9,
        "yardage": 341
      },
      {
        "number": 11,
        "par": 3,
        "si": 15,
        "yardage": 150
      },
      {
        "number": 12,
        "par": 5,
        "si": 1,
        "yardage": 421
      },
      {
        "number": 13,
        "par": 4,
        "si": 11,
        "yardage": 327
      },
      {
        "number": 14,
        "par": 4,
        "si": 13,
        "yardage": 330
      },
      {
        "number": 15,
        "par": 5,
        "si": 3,
        "yardage": 409
      },
      {
        "number": 16,
        "par": 3,
        "si": 17,
        "yardage": 140
      },
      {
        "number": 17,
        "par": 4,
        "si": 7,
        "yardage": 320
      },
      {
        "number": 18,
        "par": 4,
        "si": 5,
        "yardage": 327
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 130,
        "rating": 72.6
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 127,
        "rating": 70.4
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 122,
        "rating": 68
      },
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 126,
        "rating": 71.7
      }
    ]
  },
  {
    "id": "gl_highland-glen-golf-club",
    "name": "Highland Glen Golf Club",
    "city": "Priceville",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 7,
        "yardage": 298
      },
      {
        "number": 2,
        "par": 4,
        "si": 1,
        "yardage": 241
      },
      {
        "number": 3,
        "par": 3,
        "si": 13,
        "yardage": 91
      },
      {
        "number": 4,
        "par": 4,
        "si": 11,
        "yardage": 285
      },
      {
        "number": 5,
        "par": 4,
        "si": 9,
        "yardage": 262
      },
      {
        "number": 6,
        "par": 3,
        "si": 17,
        "yardage": 116
      },
      {
        "number": 7,
        "par": 4,
        "si": 15,
        "yardage": 251
      },
      {
        "number": 8,
        "par": 5,
        "si": 3,
        "yardage": 526
      },
      {
        "number": 9,
        "par": 4,
        "si": 5,
        "yardage": 282
      },
      {
        "number": 10,
        "par": 4,
        "si": 4,
        "yardage": 390
      },
      {
        "number": 11,
        "par": 4,
        "si": 10,
        "yardage": 276
      },
      {
        "number": 12,
        "par": 4,
        "si": 14,
        "yardage": 334
      },
      {
        "number": 13,
        "par": 3,
        "si": 18,
        "yardage": 114
      },
      {
        "number": 14,
        "par": 5,
        "si": 2,
        "yardage": 452
      },
      {
        "number": 15,
        "par": 3,
        "si": 8,
        "yardage": 150
      },
      {
        "number": 16,
        "par": 4,
        "si": 12,
        "yardage": 346
      },
      {
        "number": 17,
        "par": 4,
        "si": 16,
        "yardage": 257
      },
      {
        "number": 18,
        "par": 4,
        "si": 6,
        "yardage": 373
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 124,
        "rating": 69.5
      },
      {
        "id": "green",
        "name": "Green",
        "color": "#047857",
        "colors": [
          "#047857"
        ],
        "slope": 121,
        "rating": 67
      },
      {
        "id": "yellow",
        "name": "Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 104,
        "rating": 64.4
      }
    ]
  },
  {
    "id": "gl_hockley-valley-golf-course",
    "name": "Hockley Valley Golf Course",
    "city": "Mono",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 7,
        "yardage": 314
      },
      {
        "number": 2,
        "par": 4,
        "si": 9,
        "yardage": 271
      },
      {
        "number": 3,
        "par": 3,
        "si": 17,
        "yardage": 87
      },
      {
        "number": 4,
        "par": 5,
        "si": 3,
        "yardage": 402
      },
      {
        "number": 5,
        "par": 3,
        "si": 13,
        "yardage": 109
      },
      {
        "number": 6,
        "par": 5,
        "si": 5,
        "yardage": 427
      },
      {
        "number": 7,
        "par": 4,
        "si": 1,
        "yardage": 366
      },
      {
        "number": 8,
        "par": 4,
        "si": 11,
        "yardage": 304
      },
      {
        "number": 9,
        "par": 4,
        "si": 15,
        "yardage": 209
      },
      {
        "number": 10,
        "par": 3,
        "si": 14,
        "yardage": 116
      },
      {
        "number": 11,
        "par": 5,
        "si": 4,
        "yardage": 335
      },
      {
        "number": 12,
        "par": 3,
        "si": 12,
        "yardage": 145
      },
      {
        "number": 13,
        "par": 5,
        "si": 8,
        "yardage": 414
      },
      {
        "number": 14,
        "par": 3,
        "si": 18,
        "yardage": 105
      },
      {
        "number": 15,
        "par": 4,
        "si": 10,
        "yardage": 268
      },
      {
        "number": 16,
        "par": 5,
        "si": 2,
        "yardage": 400
      },
      {
        "number": 17,
        "par": 3,
        "si": 16,
        "yardage": 108
      },
      {
        "number": 18,
        "par": 4,
        "si": 6,
        "yardage": 298
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 130,
        "rating": 71
      },
      {
        "id": "black-gold",
        "name": "Black/Gold",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 128,
        "rating": 69.8
      },
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 126,
        "rating": 68.7
      },
      {
        "id": "gold-green",
        "name": "Gold/Green",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 121,
        "rating": 67.8
      },
      {
        "id": "green",
        "name": "Green",
        "color": "#047857",
        "colors": [
          "#047857"
        ],
        "slope": 120,
        "rating": 66.1
      },
      {
        "id": "green-white",
        "name": "Green/White",
        "color": "#047857",
        "colors": [
          "#047857"
        ],
        "slope": 125,
        "rating": 69.6
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 126,
        "rating": 62.3
      }
    ]
  },
  {
    "id": "gl_homestead-golf-club--2",
    "name": "Homestead Golf Club",
    "city": "Durham",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 5,
        "yardage": 388
      },
      {
        "number": 2,
        "par": 5,
        "si": 1,
        "yardage": 431
      },
      {
        "number": 3,
        "par": 3,
        "si": 11,
        "yardage": 133
      },
      {
        "number": 4,
        "par": 4,
        "si": 15,
        "yardage": 235
      },
      {
        "number": 5,
        "par": 4,
        "si": 13,
        "yardage": 247
      },
      {
        "number": 6,
        "par": 4,
        "si": 3,
        "yardage": 312
      },
      {
        "number": 7,
        "par": 3,
        "si": 17,
        "yardage": 108
      },
      {
        "number": 8,
        "par": 4,
        "si": 7,
        "yardage": 307
      },
      {
        "number": 9,
        "par": 3,
        "si": 9,
        "yardage": 115
      },
      {
        "number": 10,
        "par": 4,
        "si": 14,
        "yardage": 246
      },
      {
        "number": 11,
        "par": 4,
        "si": 16,
        "yardage": 213
      },
      {
        "number": 12,
        "par": 3,
        "si": 10,
        "yardage": 112
      },
      {
        "number": 13,
        "par": 4,
        "si": 8,
        "yardage": 207
      },
      {
        "number": 14,
        "par": 4,
        "si": 6,
        "yardage": 283
      },
      {
        "number": 15,
        "par": 5,
        "si": 4,
        "yardage": 477
      },
      {
        "number": 16,
        "par": 4,
        "si": 18,
        "yardage": 237
      },
      {
        "number": 17,
        "par": 3,
        "si": 2,
        "yardage": 168
      },
      {
        "number": 18,
        "par": 4,
        "si": 12,
        "yardage": 271
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 117,
        "rating": 65.4
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 105,
        "rating": 63
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 109,
        "rating": 69
      }
    ]
  },
  {
    "id": "gl_horseshoe-resort-valley",
    "name": "Horseshoe Resort Valley",
    "city": "Barrie",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 7,
        "yardage": 487
      },
      {
        "number": 2,
        "par": 3,
        "si": 3,
        "yardage": 121
      },
      {
        "number": 3,
        "par": 3,
        "si": 15,
        "yardage": 129
      },
      {
        "number": 4,
        "par": 4,
        "si": 17,
        "yardage": 301
      },
      {
        "number": 5,
        "par": 4,
        "si": 1,
        "yardage": 348
      },
      {
        "number": 6,
        "par": 3,
        "si": 11,
        "yardage": 144
      },
      {
        "number": 7,
        "par": 4,
        "si": 5,
        "yardage": 258
      },
      {
        "number": 8,
        "par": 4,
        "si": 13,
        "yardage": 290
      },
      {
        "number": 9,
        "par": 3,
        "si": 9,
        "yardage": 158
      },
      {
        "number": 10,
        "par": 4,
        "si": 8,
        "yardage": 285
      },
      {
        "number": 11,
        "par": 4,
        "si": 4,
        "yardage": 316
      },
      {
        "number": 12,
        "par": 4,
        "si": 16,
        "yardage": 262
      },
      {
        "number": 13,
        "par": 3,
        "si": 18,
        "yardage": 130
      },
      {
        "number": 14,
        "par": 5,
        "si": 2,
        "yardage": 462
      },
      {
        "number": 15,
        "par": 4,
        "si": 12,
        "yardage": 247
      },
      {
        "number": 16,
        "par": 3,
        "si": 6,
        "yardage": 135
      },
      {
        "number": 17,
        "par": 4,
        "si": 14,
        "yardage": 210
      },
      {
        "number": 18,
        "par": 5,
        "si": 10,
        "yardage": 402
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 121,
        "rating": 66.8
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 120,
        "rating": 65.4
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 113,
        "rating": 67.3
      }
    ]
  },
  {
    "id": "gl_innisbrook-golf-course",
    "name": "Innisbrook Golf Course",
    "city": "Barrie",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 3,
        "si": 12,
        "yardage": 94
      },
      {
        "number": 2,
        "par": 3,
        "si": 14,
        "yardage": 111
      },
      {
        "number": 3,
        "par": 4,
        "si": 10,
        "yardage": 235
      },
      {
        "number": 4,
        "par": 3,
        "si": 8,
        "yardage": 106
      },
      {
        "number": 5,
        "par": 4,
        "si": 6,
        "yardage": 297
      },
      {
        "number": 6,
        "par": 4,
        "si": 18,
        "yardage": 232
      },
      {
        "number": 7,
        "par": 4,
        "si": 16,
        "yardage": 262
      },
      {
        "number": 8,
        "par": 3,
        "si": 2,
        "yardage": 93
      },
      {
        "number": 9,
        "par": 3,
        "si": 4,
        "yardage": 109
      },
      {
        "number": 10,
        "par": 3,
        "si": 5,
        "yardage": 136
      },
      {
        "number": 11,
        "par": 3,
        "si": 17,
        "yardage": 88
      },
      {
        "number": 12,
        "par": 4,
        "si": 13,
        "yardage": 236
      },
      {
        "number": 13,
        "par": 3,
        "si": 7,
        "yardage": 96
      },
      {
        "number": 14,
        "par": 4,
        "si": 15,
        "yardage": 249
      },
      {
        "number": 15,
        "par": 3,
        "si": 11,
        "yardage": 100
      },
      {
        "number": 16,
        "par": 5,
        "si": 3,
        "yardage": 477
      },
      {
        "number": 17,
        "par": 3,
        "si": 9,
        "yardage": 105
      },
      {
        "number": 18,
        "par": 4,
        "si": 1,
        "yardage": 227
      }
    ]
  },
  {
    "id": "gl_iron-and-the-eagle-golf-and-country-club",
    "name": "Iron And The Eagle Golf And Country Club",
    "city": "Mono",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 3,
        "yardage": 423
      },
      {
        "number": 2,
        "par": 4,
        "si": 1,
        "yardage": 352
      },
      {
        "number": 3,
        "par": 4,
        "si": 5,
        "yardage": 317
      },
      {
        "number": 4,
        "par": 3,
        "si": 15,
        "yardage": 85
      },
      {
        "number": 5,
        "par": 4,
        "si": 9,
        "yardage": 311
      },
      {
        "number": 6,
        "par": 4,
        "si": 13,
        "yardage": 262
      },
      {
        "number": 7,
        "par": 4,
        "si": 17,
        "yardage": 239
      },
      {
        "number": 8,
        "par": 3,
        "si": 11,
        "yardage": 129
      },
      {
        "number": 9,
        "par": 4,
        "si": 7,
        "yardage": 365
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 126,
        "rating": 34.8
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 126,
        "rating": 34.7
      }
    ]
  },
  {
    "id": "gl_lake-st-george-golf-club",
    "name": "Lake St George Golf Club",
    "city": "Washago",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 1,
        "yardage": 373
      },
      {
        "number": 2,
        "par": 3,
        "si": 9,
        "yardage": 75
      },
      {
        "number": 3,
        "par": 5,
        "si": 17,
        "yardage": 372
      },
      {
        "number": 4,
        "par": 4,
        "si": 13,
        "yardage": 283
      },
      {
        "number": 5,
        "par": 4,
        "si": 15,
        "yardage": 256
      },
      {
        "number": 6,
        "par": 4,
        "si": 3,
        "yardage": 351
      },
      {
        "number": 7,
        "par": 3,
        "si": 7,
        "yardage": 134
      },
      {
        "number": 8,
        "par": 4,
        "si": 5,
        "yardage": 259
      },
      {
        "number": 9,
        "par": 4,
        "si": 11,
        "yardage": 246
      },
      {
        "number": 10,
        "par": 4,
        "si": 16,
        "yardage": 274
      },
      {
        "number": 11,
        "par": 3,
        "si": 8,
        "yardage": 167
      },
      {
        "number": 12,
        "par": 4,
        "si": 6,
        "yardage": 346
      },
      {
        "number": 13,
        "par": 4,
        "si": 2,
        "yardage": 327
      },
      {
        "number": 14,
        "par": 3,
        "si": 10,
        "yardage": 87
      },
      {
        "number": 15,
        "par": 5,
        "si": 4,
        "yardage": 410
      },
      {
        "number": 16,
        "par": 4,
        "si": 12,
        "yardage": 251
      },
      {
        "number": 17,
        "par": 4,
        "si": 14,
        "yardage": 318
      },
      {
        "number": 18,
        "par": 5,
        "si": 18,
        "yardage": 413
      }
    ],
    "tees": [
      {
        "id": "north-south-blue",
        "name": "North/South - Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 126,
        "rating": 70.2
      },
      {
        "id": "north-south-white",
        "name": "North/South - White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 123,
        "rating": 68.7
      },
      {
        "id": "west-north-blue",
        "name": "West/North - Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 125,
        "rating": 69.1
      },
      {
        "id": "south-west-white",
        "name": "South/West - White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 123,
        "rating": 68
      },
      {
        "id": "west-north-white",
        "name": "West/North - White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 122,
        "rating": 66.7
      },
      {
        "id": "north-south-yellow",
        "name": "North/South - Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 118,
        "rating": 65.4
      },
      {
        "id": "south-west-yellow",
        "name": "South/West - Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 121,
        "rating": 64.7
      },
      {
        "id": "west-north-yellow",
        "name": "West/North - Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 125,
        "rating": 69.1
      }
    ]
  },
  {
    "id": "gl_lakeview-house-golf-course",
    "name": "Lakeview House Golf Course",
    "city": "Jacksons Point",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 7,
        "yardage": 250
      },
      {
        "number": 2,
        "par": 5,
        "si": 1,
        "yardage": 450
      },
      {
        "number": 3,
        "par": 3,
        "si": 9,
        "yardage": 180
      },
      {
        "number": 4,
        "par": 4,
        "si": 3,
        "yardage": 284
      },
      {
        "number": 5,
        "par": 4,
        "si": 15,
        "yardage": 258
      },
      {
        "number": 6,
        "par": 3,
        "si": 11,
        "yardage": 186
      },
      {
        "number": 7,
        "par": 4,
        "si": 13,
        "yardage": 273
      },
      {
        "number": 8,
        "par": 4,
        "si": 5,
        "yardage": 337
      },
      {
        "number": 9,
        "par": 3,
        "si": 17,
        "yardage": 130
      }
    ]
  },
  {
    "id": "gl_landings-of-willow-creek",
    "name": "Landings Of Willow Creek",
    "city": "Barrie",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 7,
        "yardage": 319
      },
      {
        "number": 2,
        "par": 3,
        "si": 15,
        "yardage": 135
      },
      {
        "number": 3,
        "par": 4,
        "si": 9,
        "yardage": 274
      },
      {
        "number": 4,
        "par": 5,
        "si": 3,
        "yardage": 335
      },
      {
        "number": 5,
        "par": 4,
        "si": 13,
        "yardage": 261
      },
      {
        "number": 6,
        "par": 5,
        "si": 1,
        "yardage": 379
      },
      {
        "number": 7,
        "par": 4,
        "si": 5,
        "yardage": 270
      },
      {
        "number": 8,
        "par": 3,
        "si": 17,
        "yardage": 99
      },
      {
        "number": 9,
        "par": 4,
        "si": 11,
        "yardage": 280
      }
    ]
  },
  {
    "id": "gl_legacy-pines-golf-club",
    "name": "Legacy Pines Golf Club",
    "city": "Palgrave",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 7,
        "yardage": 342
      },
      {
        "number": 2,
        "par": 4,
        "si": 5,
        "yardage": 331
      },
      {
        "number": 3,
        "par": 4,
        "si": 1,
        "yardage": 326
      },
      {
        "number": 4,
        "par": 4,
        "si": 9,
        "yardage": 221
      },
      {
        "number": 5,
        "par": 3,
        "si": 13,
        "yardage": 135
      },
      {
        "number": 6,
        "par": 4,
        "si": 3,
        "yardage": 305
      },
      {
        "number": 7,
        "par": 4,
        "si": 17,
        "yardage": 265
      },
      {
        "number": 8,
        "par": 4,
        "si": 11,
        "yardage": 229
      },
      {
        "number": 9,
        "par": 3,
        "si": 15,
        "yardage": 135
      }
    ]
  },
  {
    "id": "gl_legacy-ridge-golf-club",
    "name": "Legacy Ridge Golf Club",
    "city": "Owen Sound",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 4,
        "yardage": 440
      },
      {
        "number": 2,
        "par": 3,
        "si": 16,
        "yardage": 120
      },
      {
        "number": 3,
        "par": 4,
        "si": 6,
        "yardage": 315
      },
      {
        "number": 4,
        "par": 4,
        "si": 12,
        "yardage": 225
      },
      {
        "number": 5,
        "par": 5,
        "si": 2,
        "yardage": 360
      },
      {
        "number": 6,
        "par": 4,
        "si": 8,
        "yardage": 260
      },
      {
        "number": 7,
        "par": 4,
        "si": 10,
        "yardage": 286
      },
      {
        "number": 8,
        "par": 3,
        "si": 18,
        "yardage": 100
      },
      {
        "number": 9,
        "par": 4,
        "si": 14,
        "yardage": 205
      },
      {
        "number": 10,
        "par": 4,
        "si": 5,
        "yardage": 340
      },
      {
        "number": 11,
        "par": 4,
        "si": 7,
        "yardage": 270
      },
      {
        "number": 12,
        "par": 3,
        "si": 17,
        "yardage": 100
      },
      {
        "number": 13,
        "par": 4,
        "si": 1,
        "yardage": 370
      },
      {
        "number": 14,
        "par": 3,
        "si": 13,
        "yardage": 135
      },
      {
        "number": 15,
        "par": 4,
        "si": 11,
        "yardage": 280
      },
      {
        "number": 16,
        "par": 5,
        "si": 3,
        "yardage": 415
      },
      {
        "number": 17,
        "par": 3,
        "si": 15,
        "yardage": 135
      },
      {
        "number": 18,
        "par": 5,
        "si": 9,
        "yardage": 355
      }
    ],
    "tees": [
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 116,
        "rating": 68.4
      },
      {
        "id": "silver",
        "name": "Silver",
        "color": "#c0c0c0",
        "colors": [
          "#c0c0c0"
        ],
        "slope": 114,
        "rating": 67
      },
      {
        "id": "hybrid",
        "name": "Hybrid",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 112,
        "rating": 65.4
      },
      {
        "id": "fusion",
        "name": "Fusion",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 103,
        "rating": 63.6
      },
      {
        "id": "bronze",
        "name": "Bronze",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 98,
        "rating": 61.7
      }
    ]
  },
  {
    "id": "gl_lynbrook-family-golf-centre",
    "name": "Lynbrook Family Golf Centre",
    "city": "Amaranth",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 3,
        "si": 11,
        "yardage": 110
      },
      {
        "number": 2,
        "par": 3,
        "si": 9,
        "yardage": 140
      },
      {
        "number": 3,
        "par": 3,
        "si": 17,
        "yardage": 70
      },
      {
        "number": 4,
        "par": 3,
        "si": 3,
        "yardage": 145
      },
      {
        "number": 5,
        "par": 3,
        "si": 7,
        "yardage": 125
      },
      {
        "number": 6,
        "par": 3,
        "si": 15,
        "yardage": 75
      },
      {
        "number": 7,
        "par": 3,
        "si": 5,
        "yardage": 135
      },
      {
        "number": 8,
        "par": 3,
        "si": 13,
        "yardage": 105
      },
      {
        "number": 9,
        "par": 3,
        "si": 1,
        "yardage": 160
      }
    ]
  },
  {
    "id": "gl_markdale-country-club",
    "name": "Markdale Country Club",
    "city": "Markdale",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 3,
        "yardage": 406
      },
      {
        "number": 2,
        "par": 3,
        "si": 15,
        "yardage": 131
      },
      {
        "number": 3,
        "par": 5,
        "si": 11,
        "yardage": 406
      },
      {
        "number": 4,
        "par": 3,
        "si": 5,
        "yardage": 132
      },
      {
        "number": 5,
        "par": 4,
        "si": 9,
        "yardage": 304
      },
      {
        "number": 6,
        "par": 4,
        "si": 1,
        "yardage": 266
      },
      {
        "number": 7,
        "par": 3,
        "si": 7,
        "yardage": 93
      },
      {
        "number": 8,
        "par": 4,
        "si": 13,
        "yardage": 202
      },
      {
        "number": 9,
        "par": 4,
        "si": 17,
        "yardage": 286
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 103,
        "rating": 33
      }
    ]
  },
  {
    "id": "gl_meaford-golf-and-country-club",
    "name": "Meaford Golf And Country Club",
    "city": "Meaford",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 1,
        "yardage": 370
      },
      {
        "number": 2,
        "par": 3,
        "si": 2,
        "yardage": 78
      },
      {
        "number": 3,
        "par": 4,
        "si": 3,
        "yardage": 258
      },
      {
        "number": 4,
        "par": 4,
        "si": 4,
        "yardage": 297
      },
      {
        "number": 5,
        "par": 5,
        "si": 5,
        "yardage": 391
      },
      {
        "number": 6,
        "par": 4,
        "si": 6,
        "yardage": 259
      },
      {
        "number": 7,
        "par": 4,
        "si": 7,
        "yardage": 212
      },
      {
        "number": 8,
        "par": 4,
        "si": 8,
        "yardage": 253
      },
      {
        "number": 9,
        "par": 3,
        "si": 9,
        "yardage": 81
      },
      {
        "number": 10,
        "par": 4,
        "si": 10,
        "yardage": 257
      },
      {
        "number": 11,
        "par": 4,
        "si": 11,
        "yardage": 249
      },
      {
        "number": 12,
        "par": 5,
        "si": 12,
        "yardage": 380
      },
      {
        "number": 13,
        "par": 4,
        "si": 13,
        "yardage": 325
      },
      {
        "number": 14,
        "par": 3,
        "si": 14,
        "yardage": 142
      },
      {
        "number": 15,
        "par": 4,
        "si": 15,
        "yardage": 335
      },
      {
        "number": 16,
        "par": 5,
        "si": 16,
        "yardage": 401
      },
      {
        "number": 17,
        "par": 4,
        "si": 17,
        "yardage": 310
      },
      {
        "number": 18,
        "par": 3,
        "si": 18,
        "yardage": 75
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 127,
        "rating": 67.9
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 120,
        "rating": 65.9
      },
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 107,
        "rating": 64.7
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 102,
        "rating": 63.5
      }
    ]
  },
  {
    "id": "gl_midland-golf-and-country-club",
    "name": "Midland Golf And Country Club",
    "city": "Midland",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 9,
        "yardage": 374
      },
      {
        "number": 2,
        "par": 3,
        "si": 15,
        "yardage": 101
      },
      {
        "number": 3,
        "par": 4,
        "si": 5,
        "yardage": 269
      },
      {
        "number": 4,
        "par": 4,
        "si": 7,
        "yardage": 324
      },
      {
        "number": 5,
        "par": 4,
        "si": 1,
        "yardage": 395
      },
      {
        "number": 6,
        "par": 4,
        "si": 13,
        "yardage": 287
      },
      {
        "number": 7,
        "par": 3,
        "si": 17,
        "yardage": 155
      },
      {
        "number": 8,
        "par": 4,
        "si": 3,
        "yardage": 380
      },
      {
        "number": 9,
        "par": 4,
        "si": 11,
        "yardage": 396
      },
      {
        "number": 10,
        "par": 4,
        "si": 14,
        "yardage": 396
      },
      {
        "number": 11,
        "par": 3,
        "si": 10,
        "yardage": 167
      },
      {
        "number": 12,
        "par": 4,
        "si": 16,
        "yardage": 269
      },
      {
        "number": 13,
        "par": 3,
        "si": 18,
        "yardage": 130
      },
      {
        "number": 14,
        "par": 4,
        "si": 12,
        "yardage": 280
      },
      {
        "number": 15,
        "par": 5,
        "si": 8,
        "yardage": 436
      },
      {
        "number": 16,
        "par": 4,
        "si": 2,
        "yardage": 364
      },
      {
        "number": 17,
        "par": 4,
        "si": 4,
        "yardage": 374
      },
      {
        "number": 18,
        "par": 4,
        "si": 6,
        "yardage": 344
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 126,
        "rating": 71.2
      },
      {
        "id": "hybrid-long",
        "name": "Hybrid Long",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 127,
        "rating": 70.6
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 125,
        "rating": 70
      },
      {
        "id": "hybrid-short",
        "name": "Hybrid Short",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 121,
        "rating": 68.8
      },
      {
        "id": "yellow",
        "name": "Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 117,
        "rating": 67.2
      }
    ]
  },
  {
    "id": "gl_mono-hills-country-club",
    "name": "Mono Hills Country Club",
    "city": "Orangeville",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 11,
        "yardage": 250
      },
      {
        "number": 2,
        "par": 3,
        "si": 17,
        "yardage": 110
      },
      {
        "number": 3,
        "par": 5,
        "si": 3,
        "yardage": 400
      },
      {
        "number": 4,
        "par": 4,
        "si": 13,
        "yardage": 250
      },
      {
        "number": 5,
        "par": 4,
        "si": 7,
        "yardage": 265
      },
      {
        "number": 6,
        "par": 3,
        "si": 15,
        "yardage": 105
      },
      {
        "number": 7,
        "par": 5,
        "si": 5,
        "yardage": 375
      },
      {
        "number": 8,
        "par": 4,
        "si": 1,
        "yardage": 345
      },
      {
        "number": 9,
        "par": 3,
        "si": 9,
        "yardage": 155
      },
      {
        "number": 10,
        "par": 5,
        "si": 18,
        "yardage": 365
      },
      {
        "number": 11,
        "par": 3,
        "si": 6,
        "yardage": 160
      },
      {
        "number": 12,
        "par": 4,
        "si": 10,
        "yardage": 280
      },
      {
        "number": 13,
        "par": 4,
        "si": 2,
        "yardage": 315
      },
      {
        "number": 14,
        "par": 4,
        "si": 8,
        "yardage": 300
      },
      {
        "number": 15,
        "par": 3,
        "si": 14,
        "yardage": 120
      },
      {
        "number": 16,
        "par": 4,
        "si": 4,
        "yardage": 305
      },
      {
        "number": 17,
        "par": 5,
        "si": 12,
        "yardage": 400
      },
      {
        "number": 18,
        "par": 3,
        "si": 16,
        "yardage": 125
      }
    ]
  },
  {
    "id": "gl_monterra-golf-course",
    "name": "Monterra Golf Course",
    "city": "Blue Mountains",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 17,
        "yardage": 392
      },
      {
        "number": 2,
        "par": 3,
        "si": 9,
        "yardage": 90
      },
      {
        "number": 3,
        "par": 4,
        "si": 15,
        "yardage": 248
      },
      {
        "number": 4,
        "par": 4,
        "si": 5,
        "yardage": 340
      },
      {
        "number": 5,
        "par": 4,
        "si": 1,
        "yardage": 320
      },
      {
        "number": 6,
        "par": 3,
        "si": 11,
        "yardage": 106
      },
      {
        "number": 7,
        "par": 4,
        "si": 13,
        "yardage": 308
      },
      {
        "number": 8,
        "par": 4,
        "si": 7,
        "yardage": 343
      },
      {
        "number": 9,
        "par": 5,
        "si": 3,
        "yardage": 428
      },
      {
        "number": 10,
        "par": 3,
        "si": 14,
        "yardage": 119
      },
      {
        "number": 11,
        "par": 5,
        "si": 6,
        "yardage": 469
      },
      {
        "number": 12,
        "par": 3,
        "si": 18,
        "yardage": 113
      },
      {
        "number": 13,
        "par": 5,
        "si": 10,
        "yardage": 474
      },
      {
        "number": 14,
        "par": 4,
        "si": 4,
        "yardage": 297
      },
      {
        "number": 15,
        "par": 3,
        "si": 16,
        "yardage": 59
      },
      {
        "number": 16,
        "par": 4,
        "si": 2,
        "yardage": 336
      },
      {
        "number": 17,
        "par": 4,
        "si": 12,
        "yardage": 302
      },
      {
        "number": 18,
        "par": 5,
        "si": 8,
        "yardage": 395
      }
    ],
    "tees": [
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 138,
        "rating": 71.7
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 125,
        "rating": 68.7
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 117,
        "rating": 64.9
      }
    ]
  },
  {
    "id": "gl_mount-forest-golf-and-country-club",
    "name": "Mount Forest Golf And Country Club",
    "city": "Ayton",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 3,
        "si": 5,
        "yardage": 173
      },
      {
        "number": 2,
        "par": 4,
        "si": 7,
        "yardage": 344
      },
      {
        "number": 3,
        "par": 3,
        "si": 9,
        "yardage": 136
      },
      {
        "number": 4,
        "par": 4,
        "si": 11,
        "yardage": 288
      },
      {
        "number": 5,
        "par": 3,
        "si": 3,
        "yardage": 189
      },
      {
        "number": 6,
        "par": 3,
        "si": 13,
        "yardage": 150
      },
      {
        "number": 7,
        "par": 4,
        "si": 17,
        "yardage": 200
      },
      {
        "number": 8,
        "par": 4,
        "si": 15,
        "yardage": 200
      },
      {
        "number": 9,
        "par": 5,
        "si": 1,
        "yardage": 460
      }
    ]
  },
  {
    "id": "gl_national-pines-golf-club",
    "name": "National Pines Golf Club",
    "city": "Innisfil",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 7,
        "yardage": 421
      },
      {
        "number": 2,
        "par": 4,
        "si": 11,
        "yardage": 268
      },
      {
        "number": 3,
        "par": 4,
        "si": 5,
        "yardage": 312
      },
      {
        "number": 4,
        "par": 4,
        "si": 13,
        "yardage": 274
      },
      {
        "number": 5,
        "par": 4,
        "si": 1,
        "yardage": 335
      },
      {
        "number": 6,
        "par": 3,
        "si": 15,
        "yardage": 92
      },
      {
        "number": 7,
        "par": 4,
        "si": 9,
        "yardage": 268
      },
      {
        "number": 8,
        "par": 3,
        "si": 17,
        "yardage": 108
      },
      {
        "number": 9,
        "par": 5,
        "si": 3,
        "yardage": 413
      },
      {
        "number": 10,
        "par": 5,
        "si": 8,
        "yardage": 373
      },
      {
        "number": 11,
        "par": 4,
        "si": 12,
        "yardage": 304
      },
      {
        "number": 12,
        "par": 4,
        "si": 4,
        "yardage": 314
      },
      {
        "number": 13,
        "par": 3,
        "si": 16,
        "yardage": 101
      },
      {
        "number": 14,
        "par": 5,
        "si": 2,
        "yardage": 411
      },
      {
        "number": 15,
        "par": 4,
        "si": 6,
        "yardage": 279
      },
      {
        "number": 16,
        "par": 3,
        "si": 18,
        "yardage": 97
      },
      {
        "number": 17,
        "par": 4,
        "si": 14,
        "yardage": 300
      },
      {
        "number": 18,
        "par": 4,
        "si": 10,
        "yardage": 310
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 148,
        "rating": 74
      },
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 144,
        "rating": 72
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 137,
        "rating": 70.5
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 125,
        "rating": 67
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 115,
        "rating": 64.5
      }
    ]
  },
  {
    "id": "gl_northern-dunes-golf-club",
    "name": "Northern Dunes Golf Club",
    "city": "Hepworth",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 16,
        "yardage": 336
      },
      {
        "number": 2,
        "par": 5,
        "si": 17,
        "yardage": 452
      },
      {
        "number": 3,
        "par": 4,
        "si": 4,
        "yardage": 388
      },
      {
        "number": 4,
        "par": 3,
        "si": 18,
        "yardage": 138
      },
      {
        "number": 5,
        "par": 4,
        "si": 6,
        "yardage": 376
      },
      {
        "number": 6,
        "par": 3,
        "si": 10,
        "yardage": 156
      },
      {
        "number": 7,
        "par": 4,
        "si": 1,
        "yardage": 364
      },
      {
        "number": 8,
        "par": 4,
        "si": 9,
        "yardage": 364
      },
      {
        "number": 9,
        "par": 5,
        "si": 12,
        "yardage": 401
      },
      {
        "number": 10,
        "par": 4,
        "si": 14,
        "yardage": 328
      },
      {
        "number": 11,
        "par": 3,
        "si": 7,
        "yardage": 162
      },
      {
        "number": 12,
        "par": 4,
        "si": 15,
        "yardage": 362
      },
      {
        "number": 13,
        "par": 4,
        "si": 5,
        "yardage": 382
      },
      {
        "number": 14,
        "par": 5,
        "si": 8,
        "yardage": 444
      },
      {
        "number": 15,
        "par": 4,
        "si": 11,
        "yardage": 376
      },
      {
        "number": 16,
        "par": 3,
        "si": 13,
        "yardage": 152
      },
      {
        "number": 17,
        "par": 4,
        "si": 3,
        "yardage": 426
      },
      {
        "number": 18,
        "par": 5,
        "si": 2,
        "yardage": 492
      }
    ],
    "tees": [
      {
        "id": "onyx",
        "name": "ONyx",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 129,
        "rating": 71.1
      },
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 124,
        "rating": 69.7
      }
    ]
  },
  {
    "id": "gl_nottawasaga-inn-ridge-course",
    "name": "Nottawasaga Inn Ridge Course",
    "city": "Alliston",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 1,
        "yardage": 476
      },
      {
        "number": 2,
        "par": 4,
        "si": 2,
        "yardage": 350
      },
      {
        "number": 3,
        "par": 4,
        "si": 3,
        "yardage": 299
      },
      {
        "number": 4,
        "par": 4,
        "si": 4,
        "yardage": 360
      },
      {
        "number": 5,
        "par": 3,
        "si": 5,
        "yardage": 118
      },
      {
        "number": 6,
        "par": 5,
        "si": 6,
        "yardage": 454
      },
      {
        "number": 7,
        "par": 4,
        "si": 7,
        "yardage": 339
      },
      {
        "number": 8,
        "par": 3,
        "si": 8,
        "yardage": 130
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 355
      },
      {
        "number": 10,
        "par": 3,
        "si": 10,
        "yardage": 93
      },
      {
        "number": 11,
        "par": 4,
        "si": 11,
        "yardage": 270
      },
      {
        "number": 12,
        "par": 4,
        "si": 12,
        "yardage": 303
      },
      {
        "number": 13,
        "par": 5,
        "si": 13,
        "yardage": 452
      },
      {
        "number": 14,
        "par": 4,
        "si": 14,
        "yardage": 320
      },
      {
        "number": 15,
        "par": 3,
        "si": 15,
        "yardage": 132
      },
      {
        "number": 16,
        "par": 4,
        "si": 16,
        "yardage": 329
      },
      {
        "number": 17,
        "par": 3,
        "si": 17,
        "yardage": 105
      },
      {
        "number": 18,
        "par": 5,
        "si": 18,
        "yardage": 414
      }
    ]
  },
  {
    "id": "gl_nottawasaga-inn-27-hole-course",
    "name": "Nottawasaga Inn 27 Hole Course",
    "city": "Alliston",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 235
      },
      {
        "number": 2,
        "par": 3,
        "si": 2,
        "yardage": 152
      },
      {
        "number": 3,
        "par": 5,
        "si": 3,
        "yardage": 480
      },
      {
        "number": 4,
        "par": 4,
        "si": 4,
        "yardage": 300
      },
      {
        "number": 5,
        "par": 4,
        "si": 5,
        "yardage": 278
      },
      {
        "number": 6,
        "par": 4,
        "si": 6,
        "yardage": 300
      },
      {
        "number": 7,
        "par": 4,
        "si": 7,
        "yardage": 413
      },
      {
        "number": 8,
        "par": 3,
        "si": 8,
        "yardage": 103
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 256
      },
      {
        "number": 10,
        "par": 4,
        "si": 10,
        "yardage": 320
      },
      {
        "number": 11,
        "par": 4,
        "si": 11,
        "yardage": 347
      },
      {
        "number": 12,
        "par": 5,
        "si": 12,
        "yardage": 450
      },
      {
        "number": 13,
        "par": 4,
        "si": 13,
        "yardage": 323
      },
      {
        "number": 14,
        "par": 3,
        "si": 14,
        "yardage": 115
      },
      {
        "number": 15,
        "par": 4,
        "si": 15,
        "yardage": 325
      },
      {
        "number": 16,
        "par": 4,
        "si": 16,
        "yardage": 340
      },
      {
        "number": 17,
        "par": 3,
        "si": 17,
        "yardage": 118
      },
      {
        "number": 18,
        "par": 4,
        "si": 18,
        "yardage": 297
      }
    ]
  },
  {
    "id": "gl_oak-bay-golf-course",
    "name": "Oak Bay Golf Course",
    "city": "Port Severn",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 9,
        "yardage": 401
      },
      {
        "number": 2,
        "par": 3,
        "si": 3,
        "yardage": 94
      },
      {
        "number": 3,
        "par": 4,
        "si": 1,
        "yardage": 300
      },
      {
        "number": 4,
        "par": 3,
        "si": 11,
        "yardage": 79
      },
      {
        "number": 5,
        "par": 4,
        "si": 5,
        "yardage": 326
      },
      {
        "number": 6,
        "par": 4,
        "si": 7,
        "yardage": 335
      },
      {
        "number": 7,
        "par": 4,
        "si": 17,
        "yardage": 265
      },
      {
        "number": 8,
        "par": 4,
        "si": 13,
        "yardage": 233
      },
      {
        "number": 9,
        "par": 5,
        "si": 15,
        "yardage": 374
      },
      {
        "number": 10,
        "par": 4,
        "si": 10,
        "yardage": 315
      },
      {
        "number": 11,
        "par": 4,
        "si": 6,
        "yardage": 299
      },
      {
        "number": 12,
        "par": 4,
        "si": 8,
        "yardage": 269
      },
      {
        "number": 13,
        "par": 4,
        "si": 16,
        "yardage": 327
      },
      {
        "number": 14,
        "par": 4,
        "si": 18,
        "yardage": 216
      },
      {
        "number": 15,
        "par": 3,
        "si": 4,
        "yardage": 68
      },
      {
        "number": 16,
        "par": 5,
        "si": 12,
        "yardage": 361
      },
      {
        "number": 17,
        "par": 3,
        "si": 14,
        "yardage": 128
      },
      {
        "number": 18,
        "par": 5,
        "si": 2,
        "yardage": 435
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 146,
        "rating": 71.4
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 139,
        "rating": 69.2
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 129,
        "rating": 66.4
      },
      {
        "id": "yellow",
        "name": "Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 131,
        "rating": 67.9
      }
    ]
  },
  {
    "id": "gl_orangeville-golf-club",
    "name": "Orangeville Golf Club",
    "city": "Orangeville",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 1,
        "yardage": 515
      },
      {
        "number": 2,
        "par": 3,
        "si": 9,
        "yardage": 200
      },
      {
        "number": 3,
        "par": 3,
        "si": 11,
        "yardage": 95
      },
      {
        "number": 4,
        "par": 4,
        "si": 17,
        "yardage": 261
      },
      {
        "number": 5,
        "par": 4,
        "si": 7,
        "yardage": 272
      },
      {
        "number": 6,
        "par": 4,
        "si": 15,
        "yardage": 272
      },
      {
        "number": 7,
        "par": 5,
        "si": 3,
        "yardage": 412
      },
      {
        "number": 8,
        "par": 3,
        "si": 13,
        "yardage": 141
      },
      {
        "number": 9,
        "par": 4,
        "si": 5,
        "yardage": 334
      }
    ],
    "tees": [
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 109,
        "rating": 32.5
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 110,
        "rating": 34.8
      }
    ]
  },
  {
    "id": "gl_orchard-beach-golf-and-country-club",
    "name": "Orchard Beach Golf And Country Club",
    "city": "Keswick",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 3,
        "yardage": 303
      },
      {
        "number": 2,
        "par": 4,
        "si": 9,
        "yardage": 348
      },
      {
        "number": 3,
        "par": 4,
        "si": 5,
        "yardage": 320
      },
      {
        "number": 4,
        "par": 3,
        "si": 17,
        "yardage": 135
      },
      {
        "number": 5,
        "par": 4,
        "si": 7,
        "yardage": 345
      },
      {
        "number": 6,
        "par": 4,
        "si": 1,
        "yardage": 405
      },
      {
        "number": 7,
        "par": 5,
        "si": 11,
        "yardage": 435
      },
      {
        "number": 8,
        "par": 3,
        "si": 15,
        "yardage": 111
      },
      {
        "number": 9,
        "par": 4,
        "si": 13,
        "yardage": 290
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 117,
        "rating": 35.1
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 115,
        "rating": 34.5
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 122,
        "rating": 35.7
      }
    ]
  },
  {
    "id": "gl_orr-lake-golf-club",
    "name": "Orr Lake Golf Club",
    "city": "Elmvale",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 9,
        "yardage": 331
      },
      {
        "number": 2,
        "par": 3,
        "si": 13,
        "yardage": 119
      },
      {
        "number": 3,
        "par": 4,
        "si": 15,
        "yardage": 280
      },
      {
        "number": 4,
        "par": 3,
        "si": 17,
        "yardage": 106
      },
      {
        "number": 5,
        "par": 4,
        "si": 11,
        "yardage": 283
      },
      {
        "number": 6,
        "par": 5,
        "si": 1,
        "yardage": 599
      },
      {
        "number": 7,
        "par": 3,
        "si": 5,
        "yardage": 192
      },
      {
        "number": 8,
        "par": 4,
        "si": 3,
        "yardage": 376
      },
      {
        "number": 9,
        "par": 5,
        "si": 7,
        "yardage": 473
      },
      {
        "number": 10,
        "par": 3,
        "si": 16,
        "yardage": 182
      },
      {
        "number": 11,
        "par": 5,
        "si": 4,
        "yardage": 517
      },
      {
        "number": 12,
        "par": 4,
        "si": 18,
        "yardage": 250
      },
      {
        "number": 13,
        "par": 4,
        "si": 10,
        "yardage": 425
      },
      {
        "number": 14,
        "par": 3,
        "si": 12,
        "yardage": 151
      },
      {
        "number": 15,
        "par": 5,
        "si": 2,
        "yardage": 492
      },
      {
        "number": 16,
        "par": 4,
        "si": 6,
        "yardage": 388
      },
      {
        "number": 17,
        "par": 4,
        "si": 14,
        "yardage": 250
      },
      {
        "number": 18,
        "par": 4,
        "si": 8,
        "yardage": 359
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 128,
        "rating": 67
      }
    ]
  },
  {
    "id": "gl_oslerbrook-golf-and-country-cblu",
    "name": "Oslerbrook Golf And Country Cblu",
    "city": "Collingwood",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 11,
        "yardage": 259
      },
      {
        "number": 2,
        "par": 5,
        "si": 3,
        "yardage": 426
      },
      {
        "number": 3,
        "par": 3,
        "si": 15,
        "yardage": 117
      },
      {
        "number": 4,
        "par": 4,
        "si": 1,
        "yardage": 334
      },
      {
        "number": 5,
        "par": 3,
        "si": 17,
        "yardage": 132
      },
      {
        "number": 6,
        "par": 5,
        "si": 7,
        "yardage": 452
      },
      {
        "number": 7,
        "par": 3,
        "si": 13,
        "yardage": 124
      },
      {
        "number": 8,
        "par": 4,
        "si": 5,
        "yardage": 322
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 292
      },
      {
        "number": 10,
        "par": 4,
        "si": 10,
        "yardage": 298
      },
      {
        "number": 11,
        "par": 5,
        "si": 12,
        "yardage": 425
      },
      {
        "number": 12,
        "par": 4,
        "si": 4,
        "yardage": 323
      },
      {
        "number": 13,
        "par": 3,
        "si": 16,
        "yardage": 160
      },
      {
        "number": 14,
        "par": 4,
        "si": 6,
        "yardage": 309
      },
      {
        "number": 15,
        "par": 3,
        "si": 18,
        "yardage": 131
      },
      {
        "number": 16,
        "par": 4,
        "si": 8,
        "yardage": 261
      },
      {
        "number": 17,
        "par": 4,
        "si": 14,
        "yardage": 310
      },
      {
        "number": 18,
        "par": 5,
        "si": 2,
        "yardage": 393
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 147,
        "rating": 74.4
      },
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 131,
        "rating": 70.8
      }
    ]
  },
  {
    "id": "gl_pike-lake-g-cc-lake-course",
    "name": "Pike Lake G Cc Lake Course",
    "city": "Clifford",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 3,
        "yardage": 253
      },
      {
        "number": 2,
        "par": 4,
        "si": 9,
        "yardage": 301
      },
      {
        "number": 3,
        "par": 4,
        "si": 17,
        "yardage": 270
      },
      {
        "number": 4,
        "par": 4,
        "si": 15,
        "yardage": 336
      },
      {
        "number": 5,
        "par": 5,
        "si": 5,
        "yardage": 450
      },
      {
        "number": 6,
        "par": 5,
        "si": 11,
        "yardage": 465
      },
      {
        "number": 7,
        "par": 4,
        "si": 1,
        "yardage": 360
      },
      {
        "number": 8,
        "par": 3,
        "si": 7,
        "yardage": 162
      },
      {
        "number": 9,
        "par": 3,
        "si": 13,
        "yardage": 157
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 128,
        "rating": 35.1
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 122,
        "rating": 34.3
      },
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 121,
        "rating": 35.4
      }
    ]
  },
  {
    "id": "gl_pike-lake-g-cc-links-course",
    "name": "Pike Lake G Cc Links Course",
    "city": "Clifford",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 6,
        "yardage": 260
      },
      {
        "number": 2,
        "par": 4,
        "si": 16,
        "yardage": 235
      },
      {
        "number": 3,
        "par": 3,
        "si": 14,
        "yardage": 145
      },
      {
        "number": 4,
        "par": 4,
        "si": 18,
        "yardage": 235
      },
      {
        "number": 5,
        "par": 4,
        "si": 2,
        "yardage": 270
      },
      {
        "number": 6,
        "par": 5,
        "si": 8,
        "yardage": 430
      },
      {
        "number": 7,
        "par": 3,
        "si": 12,
        "yardage": 110
      },
      {
        "number": 8,
        "par": 4,
        "si": 10,
        "yardage": 295
      },
      {
        "number": 9,
        "par": 5,
        "si": 4,
        "yardage": 363
      },
      {
        "number": 10,
        "par": 3,
        "si": 17,
        "yardage": 115
      },
      {
        "number": 11,
        "par": 5,
        "si": 5,
        "yardage": 368
      },
      {
        "number": 12,
        "par": 4,
        "si": 15,
        "yardage": 305
      },
      {
        "number": 13,
        "par": 4,
        "si": 7,
        "yardage": 297
      },
      {
        "number": 14,
        "par": 4,
        "si": 9,
        "yardage": 280
      },
      {
        "number": 15,
        "par": 4,
        "si": 11,
        "yardage": 335
      },
      {
        "number": 16,
        "par": 4,
        "si": 1,
        "yardage": 315
      },
      {
        "number": 17,
        "par": 3,
        "si": 13,
        "yardage": 110
      },
      {
        "number": 18,
        "par": 5,
        "si": 3,
        "yardage": 458
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 133,
        "rating": 71.1
      }
    ]
  },
  {
    "id": "gl_pinewoods-golf-centre",
    "name": "Pinewoods Golf Centre",
    "city": "Sauble Beach",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 7,
        "yardage": 230
      },
      {
        "number": 2,
        "par": 3,
        "si": 13,
        "yardage": 142
      },
      {
        "number": 3,
        "par": 4,
        "si": 3,
        "yardage": 230
      },
      {
        "number": 4,
        "par": 4,
        "si": 5,
        "yardage": 265
      },
      {
        "number": 5,
        "par": 5,
        "si": 1,
        "yardage": 375
      },
      {
        "number": 6,
        "par": 3,
        "si": 17,
        "yardage": 140
      },
      {
        "number": 7,
        "par": 5,
        "si": 9,
        "yardage": 330
      },
      {
        "number": 8,
        "par": 4,
        "si": 15,
        "yardage": 175
      },
      {
        "number": 9,
        "par": 4,
        "si": 11,
        "yardage": 230
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 121,
        "rating": 35.4
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 111,
        "rating": 33.1
      },
      {
        "id": "red",
        "name": "REd",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 105,
        "rating": 33.1
      }
    ]
  },
  {
    "id": "gl_sauble-golf-and-country-club",
    "name": "Sauble Golf And Country Club",
    "city": "Hepworth",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 200
      },
      {
        "number": 2,
        "par": 4,
        "si": 2,
        "yardage": 315
      },
      {
        "number": 3,
        "par": 4,
        "si": 3,
        "yardage": 260
      },
      {
        "number": 4,
        "par": 3,
        "si": 4,
        "yardage": 145
      },
      {
        "number": 5,
        "par": 4,
        "si": 5,
        "yardage": 260
      },
      {
        "number": 6,
        "par": 4,
        "si": 6,
        "yardage": 300
      },
      {
        "number": 7,
        "par": 4,
        "si": 7,
        "yardage": 300
      },
      {
        "number": 8,
        "par": 4,
        "si": 8,
        "yardage": 245
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 255
      },
      {
        "number": 10,
        "par": 4,
        "si": 10,
        "yardage": 270
      },
      {
        "number": 11,
        "par": 4,
        "si": 11,
        "yardage": 250
      },
      {
        "number": 12,
        "par": 5,
        "si": 12,
        "yardage": 400
      },
      {
        "number": 13,
        "par": 3,
        "si": 13,
        "yardage": 85
      },
      {
        "number": 14,
        "par": 4,
        "si": 14,
        "yardage": 275
      },
      {
        "number": 15,
        "par": 3,
        "si": 15,
        "yardage": 100
      },
      {
        "number": 16,
        "par": 5,
        "si": 16,
        "yardage": 350
      },
      {
        "number": 17,
        "par": 4,
        "si": 17,
        "yardage": 315
      },
      {
        "number": 18,
        "par": 4,
        "si": 18,
        "yardage": 310
      }
    ]
  },
  {
    "id": "gl_scenic-city-golf-course",
    "name": "Scenic City Golf Course",
    "city": "Owen Sound",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 1,
        "yardage": 433
      },
      {
        "number": 2,
        "par": 4,
        "si": 4,
        "yardage": 303
      },
      {
        "number": 3,
        "par": 4,
        "si": 2,
        "yardage": 240
      },
      {
        "number": 4,
        "par": 4,
        "si": 13,
        "yardage": 293
      },
      {
        "number": 5,
        "par": 5,
        "si": 9,
        "yardage": 394
      },
      {
        "number": 6,
        "par": 3,
        "si": 10,
        "yardage": 150
      },
      {
        "number": 7,
        "par": 4,
        "si": 12,
        "yardage": 290
      },
      {
        "number": 8,
        "par": 4,
        "si": 15,
        "yardage": 300
      },
      {
        "number": 9,
        "par": 3,
        "si": 16,
        "yardage": 128
      },
      {
        "number": 10,
        "par": 4,
        "si": 6,
        "yardage": 345
      },
      {
        "number": 11,
        "par": 3,
        "si": 18,
        "yardage": 110
      },
      {
        "number": 12,
        "par": 4,
        "si": 3,
        "yardage": 335
      },
      {
        "number": 13,
        "par": 5,
        "si": 5,
        "yardage": 458
      },
      {
        "number": 14,
        "par": 3,
        "si": 17,
        "yardage": 93
      },
      {
        "number": 15,
        "par": 4,
        "si": 11,
        "yardage": 294
      },
      {
        "number": 16,
        "par": 3,
        "si": 14,
        "yardage": 127
      },
      {
        "number": 17,
        "par": 4,
        "si": 7,
        "yardage": 331
      },
      {
        "number": 18,
        "par": 5,
        "si": 8,
        "yardage": 430
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 112,
        "rating": 67.4
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 110,
        "rating": 65.4
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 111,
        "rating": 67.8
      }
    ]
  },
  {
    "id": "gl_settler-s-ghost-golf-club",
    "name": "Settler S Ghost Golf Club",
    "city": "Barrie",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 291
      },
      {
        "number": 2,
        "par": 3,
        "si": 17,
        "yardage": 108
      },
      {
        "number": 3,
        "par": 4,
        "si": 13,
        "yardage": 273
      },
      {
        "number": 4,
        "par": 4,
        "si": 11,
        "yardage": 269
      },
      {
        "number": 5,
        "par": 5,
        "si": 7,
        "yardage": 396
      },
      {
        "number": 6,
        "par": 4,
        "si": 5,
        "yardage": 249
      },
      {
        "number": 7,
        "par": 3,
        "si": 15,
        "yardage": 94
      },
      {
        "number": 8,
        "par": 5,
        "si": 3,
        "yardage": 451
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 240
      },
      {
        "number": 10,
        "par": 5,
        "si": 2,
        "yardage": 444
      },
      {
        "number": 11,
        "par": 3,
        "si": 16,
        "yardage": 105
      },
      {
        "number": 12,
        "par": 5,
        "si": 8,
        "yardage": 413
      },
      {
        "number": 13,
        "par": 4,
        "si": 10,
        "yardage": 258
      },
      {
        "number": 14,
        "par": 3,
        "si": 18,
        "yardage": 106
      },
      {
        "number": 15,
        "par": 5,
        "si": 4,
        "yardage": 467
      },
      {
        "number": 16,
        "par": 3,
        "si": 14,
        "yardage": 108
      },
      {
        "number": 17,
        "par": 4,
        "si": 12,
        "yardage": 279
      },
      {
        "number": 18,
        "par": 4,
        "si": 6,
        "yardage": 326
      }
    ],
    "tees": [
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 132,
        "rating": 70
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 123,
        "rating": 69
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 111,
        "rating": 65.4
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 109,
        "rating": 63.4
      }
    ]
  },
  {
    "id": "gl_shanty-bay-golf-and-country-club",
    "name": "Shanty Bay Golf And Country Club",
    "city": "Oro Medonte",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 5,
        "yardage": 289
      },
      {
        "number": 2,
        "par": 4,
        "si": 17,
        "yardage": 249
      },
      {
        "number": 3,
        "par": 4,
        "si": 3,
        "yardage": 273
      },
      {
        "number": 4,
        "par": 4,
        "si": 11,
        "yardage": 234
      },
      {
        "number": 5,
        "par": 3,
        "si": 13,
        "yardage": 95
      },
      {
        "number": 6,
        "par": 4,
        "si": 9,
        "yardage": 248
      },
      {
        "number": 7,
        "par": 4,
        "si": 7,
        "yardage": 210
      },
      {
        "number": 8,
        "par": 3,
        "si": 15,
        "yardage": 138
      },
      {
        "number": 9,
        "par": 5,
        "si": 1,
        "yardage": 394
      },
      {
        "number": 10,
        "par": 5,
        "si": 2,
        "yardage": 401
      },
      {
        "number": 11,
        "par": 4,
        "si": 12,
        "yardage": 298
      },
      {
        "number": 12,
        "par": 4,
        "si": 14,
        "yardage": 270
      },
      {
        "number": 13,
        "par": 5,
        "si": 8,
        "yardage": 344
      },
      {
        "number": 14,
        "par": 4,
        "si": 10,
        "yardage": 296
      },
      {
        "number": 15,
        "par": 4,
        "si": 4,
        "yardage": 307
      },
      {
        "number": 16,
        "par": 3,
        "si": 16,
        "yardage": 145
      },
      {
        "number": 17,
        "par": 3,
        "si": 18,
        "yardage": 151
      },
      {
        "number": 18,
        "par": 4,
        "si": 6,
        "yardage": 325
      }
    ],
    "tees": [
      {
        "id": "klondike-frontier-blue",
        "name": "Klondike/Frontier - Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 121,
        "rating": 69.6
      },
      {
        "id": "frontier-rangeland-blue",
        "name": "Frontier/Rangeland - Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 119,
        "rating": 68.8
      },
      {
        "id": "rangeland-klondike-blue",
        "name": "Rangeland/Klondike - Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 115,
        "rating": 67
      },
      {
        "id": "klondike-frontier-white",
        "name": "Klondike/Frontier - White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 116,
        "rating": 67.5
      },
      {
        "id": "frontier-rangeland-white",
        "name": "Frontier/Rangeland - White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 113,
        "rating": 66.4
      },
      {
        "id": "rangeland-klondike-white",
        "name": "Rangeland/Klondike - White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 111,
        "rating": 65.9
      },
      {
        "id": "klondike-frontier-yellow",
        "name": "Klondike/Frontier - Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 106,
        "rating": 65
      },
      {
        "id": "frontier-rangeland-yellow",
        "name": "Frontier/Rangeland - Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 103,
        "rating": 6.4
      },
      {
        "id": "rangeland-klondike-yellow",
        "name": "Rangeland/Klondike - Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 102,
        "rating": 63.8
      }
    ]
  },
  {
    "id": "gl_shelburne-golf-and-country-club",
    "name": "Shelburne Golf And Country Club",
    "city": "Melancthon",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 349
      },
      {
        "number": 2,
        "par": 4,
        "si": 2,
        "yardage": 344
      },
      {
        "number": 3,
        "par": 3,
        "si": 3,
        "yardage": 131
      },
      {
        "number": 4,
        "par": 4,
        "si": 4,
        "yardage": 388
      },
      {
        "number": 5,
        "par": 4,
        "si": 5,
        "yardage": 373
      },
      {
        "number": 6,
        "par": 3,
        "si": 6,
        "yardage": 142
      },
      {
        "number": 7,
        "par": 4,
        "si": 7,
        "yardage": 317
      },
      {
        "number": 8,
        "par": 5,
        "si": 8,
        "yardage": 392
      },
      {
        "number": 9,
        "par": 3,
        "si": 9,
        "yardage": 115
      },
      {
        "number": 10,
        "par": 5,
        "si": 10,
        "yardage": 438
      },
      {
        "number": 11,
        "par": 3,
        "si": 11,
        "yardage": 121
      },
      {
        "number": 12,
        "par": 5,
        "si": 12,
        "yardage": 498
      },
      {
        "number": 13,
        "par": 4,
        "si": 13,
        "yardage": 305
      },
      {
        "number": 14,
        "par": 3,
        "si": 14,
        "yardage": 114
      },
      {
        "number": 15,
        "par": 4,
        "si": 15,
        "yardage": 342
      },
      {
        "number": 16,
        "par": 5,
        "si": 16,
        "yardage": 454
      },
      {
        "number": 17,
        "par": 3,
        "si": 17,
        "yardage": 113
      },
      {
        "number": 18,
        "par": 4,
        "si": 18,
        "yardage": 241
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 122,
        "rating": 69.4
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 117,
        "rating": 68.5
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 107,
        "rating": 66.2
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 109,
        "rating": 68.7
      }
    ]
  },
  {
    "id": "gl_silver-brooke-golf-club",
    "name": "Silver Brooke Golf Club",
    "city": "Lisle",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 14,
        "yardage": 398
      },
      {
        "number": 2,
        "par": 3,
        "si": 16,
        "yardage": 100
      },
      {
        "number": 3,
        "par": 3,
        "si": 13,
        "yardage": 108
      },
      {
        "number": 4,
        "par": 4,
        "si": 15,
        "yardage": 283
      },
      {
        "number": 5,
        "par": 4,
        "si": 18,
        "yardage": 213
      },
      {
        "number": 6,
        "par": 4,
        "si": 2,
        "yardage": 322
      },
      {
        "number": 7,
        "par": 5,
        "si": 5,
        "yardage": 423
      },
      {
        "number": 8,
        "par": 4,
        "si": 14,
        "yardage": 285
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 312
      },
      {
        "number": 10,
        "par": 4,
        "si": 4,
        "yardage": 279
      },
      {
        "number": 11,
        "par": 5,
        "si": 11,
        "yardage": 445
      },
      {
        "number": 12,
        "par": 3,
        "si": 7,
        "yardage": 124
      },
      {
        "number": 13,
        "par": 4,
        "si": 3,
        "yardage": 325
      },
      {
        "number": 14,
        "par": 4,
        "si": 6,
        "yardage": 227
      },
      {
        "number": 15,
        "par": 4,
        "si": 8,
        "yardage": 338
      },
      {
        "number": 16,
        "par": 3,
        "si": 12,
        "yardage": 143
      },
      {
        "number": 17,
        "par": 5,
        "si": 10,
        "yardage": 378
      },
      {
        "number": 18,
        "par": 4,
        "si": 1,
        "yardage": 372
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 126,
        "rating": 69.6
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 122,
        "rating": 68.4
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 122,
        "rating": 68.4
      }
    ]
  },
  {
    "id": "gl_silver-lakes-golf-and-country-club",
    "name": "Silver Lakes Golf And Country Club",
    "city": "East Gillimbury",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 15,
        "yardage": 304
      },
      {
        "number": 2,
        "par": 4,
        "si": 7,
        "yardage": 252
      },
      {
        "number": 3,
        "par": 3,
        "si": 17,
        "yardage": 108
      },
      {
        "number": 4,
        "par": 4,
        "si": 13,
        "yardage": 297
      },
      {
        "number": 5,
        "par": 5,
        "si": 3,
        "yardage": 408
      },
      {
        "number": 6,
        "par": 4,
        "si": 5,
        "yardage": 285
      },
      {
        "number": 7,
        "par": 3,
        "si": 9,
        "yardage": 108
      },
      {
        "number": 8,
        "par": 5,
        "si": 11,
        "yardage": 369
      },
      {
        "number": 9,
        "par": 4,
        "si": 1,
        "yardage": 319
      },
      {
        "number": 10,
        "par": 4,
        "si": 12,
        "yardage": 308
      },
      {
        "number": 11,
        "par": 3,
        "si": 16,
        "yardage": 114
      },
      {
        "number": 12,
        "par": 4,
        "si": 2,
        "yardage": 336
      },
      {
        "number": 13,
        "par": 4,
        "si": 18,
        "yardage": 238
      },
      {
        "number": 14,
        "par": 5,
        "si": 4,
        "yardage": 469
      },
      {
        "number": 15,
        "par": 4,
        "si": 14,
        "yardage": 285
      },
      {
        "number": 16,
        "par": 4,
        "si": 6,
        "yardage": 326
      },
      {
        "number": 17,
        "par": 3,
        "si": 10,
        "yardage": 124
      },
      {
        "number": 18,
        "par": 5,
        "si": 8,
        "yardage": 442
      }
    ],
    "tees": [
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 133,
        "rating": 73.6
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 129,
        "rating": 71.2
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 125,
        "rating": 69.3
      },
      {
        "id": "yellow",
        "name": "Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 130,
        "rating": 72.9
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 123,
        "rating": 70.1
      }
    ]
  },
  {
    "id": "gl_simoro-golf-course",
    "name": "Simoro Golf Course",
    "city": "Barrie",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 9,
        "yardage": 371
      },
      {
        "number": 2,
        "par": 3,
        "si": 5,
        "yardage": 98
      },
      {
        "number": 3,
        "par": 4,
        "si": 17,
        "yardage": 230
      },
      {
        "number": 4,
        "par": 4,
        "si": 11,
        "yardage": 258
      },
      {
        "number": 5,
        "par": 4,
        "si": 13,
        "yardage": 267
      },
      {
        "number": 6,
        "par": 4,
        "si": 1,
        "yardage": 228
      },
      {
        "number": 7,
        "par": 3,
        "si": 7,
        "yardage": 117
      },
      {
        "number": 8,
        "par": 4,
        "si": 3,
        "yardage": 209
      },
      {
        "number": 9,
        "par": 5,
        "si": 15,
        "yardage": 408
      },
      {
        "number": 10,
        "par": 5,
        "si": 16,
        "yardage": 415
      },
      {
        "number": 11,
        "par": 3,
        "si": 14,
        "yardage": 81
      },
      {
        "number": 12,
        "par": 4,
        "si": 12,
        "yardage": 244
      },
      {
        "number": 13,
        "par": 4,
        "si": 6,
        "yardage": 318
      },
      {
        "number": 14,
        "par": 5,
        "si": 2,
        "yardage": 428
      },
      {
        "number": 15,
        "par": 3,
        "si": 10,
        "yardage": 93
      },
      {
        "number": 16,
        "par": 4,
        "si": 4,
        "yardage": 293
      },
      {
        "number": 17,
        "par": 4,
        "si": 18,
        "yardage": 202
      },
      {
        "number": 18,
        "par": 4,
        "si": 8,
        "yardage": 309
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 125,
        "rating": 69.5
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 127,
        "rating": 69.1
      },
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 119,
        "rating": 66.8
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 112,
        "rating": 66.7
      }
    ]
  },
  {
    "id": "gl_spring-water-golf-course",
    "name": "Spring Water Golf Course",
    "city": "Minesing",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 369
      },
      {
        "number": 2,
        "par": 3,
        "si": 2,
        "yardage": 139
      },
      {
        "number": 3,
        "par": 5,
        "si": 3,
        "yardage": 429
      },
      {
        "number": 4,
        "par": 4,
        "si": 4,
        "yardage": 286
      },
      {
        "number": 5,
        "par": 5,
        "si": 5,
        "yardage": 396
      },
      {
        "number": 6,
        "par": 3,
        "si": 6,
        "yardage": 133
      },
      {
        "number": 7,
        "par": 4,
        "si": 7,
        "yardage": 284
      },
      {
        "number": 8,
        "par": 4,
        "si": 8,
        "yardage": 278
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 265
      },
      {
        "number": 10,
        "par": 5,
        "si": 10,
        "yardage": 435
      },
      {
        "number": 11,
        "par": 4,
        "si": 11,
        "yardage": 322
      },
      {
        "number": 12,
        "par": 5,
        "si": 12,
        "yardage": 432
      },
      {
        "number": 13,
        "par": 3,
        "si": 13,
        "yardage": 133
      },
      {
        "number": 14,
        "par": 3,
        "si": 14,
        "yardage": 130
      },
      {
        "number": 15,
        "par": 4,
        "si": 15,
        "yardage": 321
      },
      {
        "number": 16,
        "par": 4,
        "si": 16,
        "yardage": 243
      },
      {
        "number": 17,
        "par": 3,
        "si": 17,
        "yardage": 125
      },
      {
        "number": 18,
        "par": 5,
        "si": 18,
        "yardage": 400
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 128,
        "rating": 69.7
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 117,
        "rating": 65.3
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 117,
        "rating": 65.3
      }
    ]
  },
  {
    "id": "gl_stone-tree-golf-club--2",
    "name": "Stone Tree Golf Club",
    "city": "Owen Sound",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 13,
        "yardage": 250
      },
      {
        "number": 2,
        "par": 5,
        "si": 1,
        "yardage": 406
      },
      {
        "number": 3,
        "par": 4,
        "si": 10,
        "yardage": 286
      },
      {
        "number": 4,
        "par": 4,
        "si": 12,
        "yardage": 266
      },
      {
        "number": 5,
        "par": 3,
        "si": 15,
        "yardage": 134
      },
      {
        "number": 6,
        "par": 4,
        "si": 5,
        "yardage": 339
      },
      {
        "number": 7,
        "par": 4,
        "si": 8,
        "yardage": 239
      },
      {
        "number": 8,
        "par": 3,
        "si": 17,
        "yardage": 115
      },
      {
        "number": 9,
        "par": 4,
        "si": 3,
        "yardage": 297
      },
      {
        "number": 10,
        "par": 4,
        "si": 4,
        "yardage": 303
      },
      {
        "number": 11,
        "par": 3,
        "si": 9,
        "yardage": 144
      },
      {
        "number": 12,
        "par": 5,
        "si": 11,
        "yardage": 437
      },
      {
        "number": 13,
        "par": 4,
        "si": 6,
        "yardage": 312
      },
      {
        "number": 14,
        "par": 4,
        "si": 7,
        "yardage": 350
      },
      {
        "number": 15,
        "par": 4,
        "si": 14,
        "yardage": 249
      },
      {
        "number": 16,
        "par": 3,
        "si": 18,
        "yardage": 121
      },
      {
        "number": 17,
        "par": 5,
        "si": 2,
        "yardage": 470
      },
      {
        "number": 18,
        "par": 3,
        "si": 16,
        "yardage": 128
      }
    ],
    "tees": [
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 126,
        "rating": 70.1
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 121,
        "rating": 69
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 118,
        "rating": 66.7
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 115,
        "rating": 68.3
      }
    ]
  },
  {
    "id": "gl_tangle-creek-golf-club",
    "name": "Tangle Creek Golf Club",
    "city": "Thornton",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 10,
        "yardage": 434
      },
      {
        "number": 2,
        "par": 4,
        "si": 18,
        "yardage": 270
      },
      {
        "number": 3,
        "par": 4,
        "si": 8,
        "yardage": 352
      },
      {
        "number": 4,
        "par": 3,
        "si": 16,
        "yardage": 102
      },
      {
        "number": 5,
        "par": 4,
        "si": 2,
        "yardage": 362
      },
      {
        "number": 6,
        "par": 4,
        "si": 4,
        "yardage": 292
      },
      {
        "number": 7,
        "par": 4,
        "si": 6,
        "yardage": 319
      },
      {
        "number": 8,
        "par": 3,
        "si": 14,
        "yardage": 158
      },
      {
        "number": 9,
        "par": 4,
        "si": 12,
        "yardage": 368
      },
      {
        "number": 10,
        "par": 4,
        "si": 15,
        "yardage": 338
      },
      {
        "number": 11,
        "par": 4,
        "si": 3,
        "yardage": 336
      },
      {
        "number": 12,
        "par": 3,
        "si": 13,
        "yardage": 129
      },
      {
        "number": 13,
        "par": 5,
        "si": 1,
        "yardage": 539
      },
      {
        "number": 14,
        "par": 4,
        "si": 9,
        "yardage": 341
      },
      {
        "number": 15,
        "par": 4,
        "si": 11,
        "yardage": 350
      },
      {
        "number": 16,
        "par": 3,
        "si": 5,
        "yardage": 143
      },
      {
        "number": 17,
        "par": 4,
        "si": 7,
        "yardage": 396
      },
      {
        "number": 18,
        "par": 5,
        "si": 17,
        "yardage": 406
      }
    ],
    "tees": [
      {
        "id": "platinum",
        "name": "Platinum",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 142,
        "rating": 75.6
      },
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 138,
        "rating": 74
      },
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 132,
        "rating": 71.4
      },
      {
        "id": "green",
        "name": "Green",
        "color": "#047857",
        "colors": [
          "#047857"
        ],
        "slope": 125,
        "rating": 69.2
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 123,
        "rating": 68.6
      }
    ]
  },
  {
    "id": "gl_club-at-bond-head-north",
    "name": "Club At Bond Head North",
    "city": "Bond Head",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 9,
        "yardage": 255
      },
      {
        "number": 2,
        "par": 4,
        "si": 5,
        "yardage": 248
      },
      {
        "number": 3,
        "par": 3,
        "si": 15,
        "yardage": 90
      },
      {
        "number": 4,
        "par": 5,
        "si": 11,
        "yardage": 394
      },
      {
        "number": 5,
        "par": 4,
        "si": 3,
        "yardage": 330
      },
      {
        "number": 6,
        "par": 4,
        "si": 13,
        "yardage": 194
      },
      {
        "number": 7,
        "par": 3,
        "si": 17,
        "yardage": 77
      },
      {
        "number": 8,
        "par": 5,
        "si": 1,
        "yardage": 481
      },
      {
        "number": 9,
        "par": 4,
        "si": 7,
        "yardage": 289
      },
      {
        "number": 10,
        "par": 4,
        "si": 4,
        "yardage": 317
      },
      {
        "number": 11,
        "par": 3,
        "si": 6,
        "yardage": 150
      },
      {
        "number": 12,
        "par": 5,
        "si": 14,
        "yardage": 419
      },
      {
        "number": 13,
        "par": 4,
        "si": 10,
        "yardage": 256
      },
      {
        "number": 14,
        "par": 3,
        "si": 16,
        "yardage": 116
      },
      {
        "number": 15,
        "par": 4,
        "si": 8,
        "yardage": 282
      },
      {
        "number": 16,
        "par": 3,
        "si": 18,
        "yardage": 87
      },
      {
        "number": 17,
        "par": 5,
        "si": 12,
        "yardage": 351
      },
      {
        "number": 18,
        "par": 4,
        "si": 2,
        "yardage": 331
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 144,
        "rating": 74.8
      },
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 140,
        "rating": 72.6
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 132,
        "rating": 69.5
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 125,
        "rating": 66.5
      },
      {
        "id": "burgundy",
        "name": "Burgundy",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 113,
        "rating": 62.4
      }
    ]
  },
  {
    "id": "gl_club-at-bond-head-south",
    "name": "Club At Bond Head South",
    "city": "Bond Head",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 15,
        "yardage": 233
      },
      {
        "number": 2,
        "par": 4,
        "si": 5,
        "yardage": 310
      },
      {
        "number": 3,
        "par": 3,
        "si": 13,
        "yardage": 137
      },
      {
        "number": 4,
        "par": 4,
        "si": 7,
        "yardage": 297
      },
      {
        "number": 5,
        "par": 3,
        "si": 17,
        "yardage": 81
      },
      {
        "number": 6,
        "par": 4,
        "si": 11,
        "yardage": 246
      },
      {
        "number": 7,
        "par": 5,
        "si": 3,
        "yardage": 461
      },
      {
        "number": 8,
        "par": 4,
        "si": 1,
        "yardage": 345
      },
      {
        "number": 9,
        "par": 5,
        "si": 9,
        "yardage": 415
      },
      {
        "number": 10,
        "par": 4,
        "si": 12,
        "yardage": 287
      },
      {
        "number": 11,
        "par": 4,
        "si": 18,
        "yardage": 263
      },
      {
        "number": 12,
        "par": 5,
        "si": 2,
        "yardage": 542
      },
      {
        "number": 13,
        "par": 4,
        "si": 16,
        "yardage": 318
      },
      {
        "number": 14,
        "par": 4,
        "si": 4,
        "yardage": 350
      },
      {
        "number": 15,
        "par": 3,
        "si": 8,
        "yardage": 152
      },
      {
        "number": 16,
        "par": 5,
        "si": 10,
        "yardage": 380
      },
      {
        "number": 17,
        "par": 3,
        "si": 14,
        "yardage": 126
      },
      {
        "number": 18,
        "par": 4,
        "si": 6,
        "yardage": 305
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 137,
        "rating": 76.4
      },
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 132,
        "rating": 74.3
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 125,
        "rating": 71.7
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 120,
        "rating": 68.7
      },
      {
        "id": "burgundy",
        "name": "Burgundy",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 113,
        "rating": 65.6
      }
    ]
  },
  {
    "id": "gl_the-ferns-golf-resort",
    "name": "The Ferns Golf Resort",
    "city": "Markdale",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 12,
        "yardage": 316
      },
      {
        "number": 2,
        "par": 3,
        "si": 4,
        "yardage": 125
      },
      {
        "number": 3,
        "par": 4,
        "si": 5,
        "yardage": 293
      },
      {
        "number": 4,
        "par": 4,
        "si": 14,
        "yardage": 321
      },
      {
        "number": 5,
        "par": 4,
        "si": 8,
        "yardage": 311
      },
      {
        "number": 6,
        "par": 4,
        "si": 10,
        "yardage": 244
      },
      {
        "number": 7,
        "par": 5,
        "si": 3,
        "yardage": 443
      },
      {
        "number": 8,
        "par": 3,
        "si": 16,
        "yardage": 155
      },
      {
        "number": 9,
        "par": 4,
        "si": 1,
        "yardage": 325
      },
      {
        "number": 10,
        "par": 4,
        "si": 7,
        "yardage": 245
      },
      {
        "number": 11,
        "par": 3,
        "si": 17,
        "yardage": 157
      },
      {
        "number": 12,
        "par": 5,
        "si": 2,
        "yardage": 429
      },
      {
        "number": 13,
        "par": 4,
        "si": 11,
        "yardage": 278
      },
      {
        "number": 14,
        "par": 4,
        "si": 15,
        "yardage": 301
      },
      {
        "number": 15,
        "par": 5,
        "si": 7,
        "yardage": 407
      },
      {
        "number": 16,
        "par": 4,
        "si": 9,
        "yardage": 313
      },
      {
        "number": 17,
        "par": 3,
        "si": 18,
        "yardage": 127
      },
      {
        "number": 18,
        "par": 5,
        "si": 6,
        "yardage": 393
      }
    ]
  },
  {
    "id": "gl_the-golf-club-at-lora-bay",
    "name": "The Golf Club At Lora Bay",
    "city": "Thornbury",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 9,
        "yardage": 385
      },
      {
        "number": 2,
        "par": 4,
        "si": 11,
        "yardage": 247
      },
      {
        "number": 3,
        "par": 3,
        "si": 17,
        "yardage": 136
      },
      {
        "number": 4,
        "par": 5,
        "si": 5,
        "yardage": 403
      },
      {
        "number": 5,
        "par": 4,
        "si": 7,
        "yardage": 276
      },
      {
        "number": 6,
        "par": 5,
        "si": 3,
        "yardage": 398
      },
      {
        "number": 7,
        "par": 3,
        "si": 15,
        "yardage": 101
      },
      {
        "number": 8,
        "par": 4,
        "si": 13,
        "yardage": 344
      },
      {
        "number": 9,
        "par": 4,
        "si": 1,
        "yardage": 316
      },
      {
        "number": 10,
        "par": 5,
        "si": 16,
        "yardage": 378
      },
      {
        "number": 11,
        "par": 4,
        "si": 4,
        "yardage": 386
      },
      {
        "number": 12,
        "par": 3,
        "si": 18,
        "yardage": 88
      },
      {
        "number": 13,
        "par": 5,
        "si": 8,
        "yardage": 443
      },
      {
        "number": 14,
        "par": 4,
        "si": 10,
        "yardage": 252
      },
      {
        "number": 15,
        "par": 3,
        "si": 12,
        "yardage": 104
      },
      {
        "number": 16,
        "par": 5,
        "si": 2,
        "yardage": 371
      },
      {
        "number": 17,
        "par": 3,
        "si": 14,
        "yardage": 133
      },
      {
        "number": 18,
        "par": 4,
        "si": 6,
        "yardage": 335
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 138,
        "rating": 74.4
      },
      {
        "id": "silver",
        "name": "Silver",
        "color": "#c0c0c0",
        "colors": [
          "#c0c0c0"
        ],
        "slope": 133,
        "rating": 72.4
      },
      {
        "id": "cobalt",
        "name": "Cobalt",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 131,
        "rating": 70.4
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 122,
        "rating": 67.7
      },
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 118,
        "rating": 65
      }
    ]
  },
  {
    "id": "gl_links-at-new-england",
    "name": "Links At New England",
    "city": "Wasaga Beach",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 10,
        "yardage": 289
      },
      {
        "number": 2,
        "par": 4,
        "si": 12,
        "yardage": 306
      },
      {
        "number": 3,
        "par": 5,
        "si": 6,
        "yardage": 471
      },
      {
        "number": 4,
        "par": 4,
        "si": 16,
        "yardage": 316
      },
      {
        "number": 5,
        "par": 3,
        "si": 8,
        "yardage": 109
      },
      {
        "number": 6,
        "par": 4,
        "si": 4,
        "yardage": 355
      },
      {
        "number": 7,
        "par": 4,
        "si": 2,
        "yardage": 301
      },
      {
        "number": 8,
        "par": 4,
        "si": 14,
        "yardage": 310
      },
      {
        "number": 9,
        "par": 4,
        "si": 18,
        "yardage": 281
      },
      {
        "number": 10,
        "par": 3,
        "si": 17,
        "yardage": 110
      },
      {
        "number": 11,
        "par": 4,
        "si": 7,
        "yardage": 355
      },
      {
        "number": 12,
        "par": 5,
        "si": 1,
        "yardage": 439
      },
      {
        "number": 13,
        "par": 3,
        "si": 13,
        "yardage": 131
      },
      {
        "number": 14,
        "par": 4,
        "si": 15,
        "yardage": 346
      },
      {
        "number": 15,
        "par": 5,
        "si": 9,
        "yardage": 449
      },
      {
        "number": 16,
        "par": 3,
        "si": 11,
        "yardage": 176
      },
      {
        "number": 17,
        "par": 4,
        "si": 5,
        "yardage": 270
      },
      {
        "number": 18,
        "par": 5,
        "si": 3,
        "yardage": 451
      }
    ],
    "tees": [
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 131,
        "rating": 72.2
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 128,
        "rating": 69.8
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 119,
        "rating": 67.6
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 125,
        "rating": 70.7
      }
    ]
  },
  {
    "id": "gl_the-nest-at-friday-harbour",
    "name": "The Nest At Friday Harbour",
    "city": "Innisfil",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 13,
        "yardage": 225
      },
      {
        "number": 2,
        "par": 3,
        "si": 17,
        "yardage": 94
      },
      {
        "number": 3,
        "par": 4,
        "si": 3,
        "yardage": 354
      },
      {
        "number": 4,
        "par": 4,
        "si": 7,
        "yardage": 272
      },
      {
        "number": 5,
        "par": 4,
        "si": 15,
        "yardage": 270
      },
      {
        "number": 6,
        "par": 5,
        "si": 5,
        "yardage": 383
      },
      {
        "number": 7,
        "par": 5,
        "si": 1,
        "yardage": 395
      },
      {
        "number": 8,
        "par": 3,
        "si": 9,
        "yardage": 141
      },
      {
        "number": 9,
        "par": 4,
        "si": 11,
        "yardage": 315
      },
      {
        "number": 10,
        "par": 4,
        "si": 16,
        "yardage": 228
      },
      {
        "number": 11,
        "par": 5,
        "si": 4,
        "yardage": 449
      },
      {
        "number": 12,
        "par": 3,
        "si": 12,
        "yardage": 134
      },
      {
        "number": 13,
        "par": 4,
        "si": 18,
        "yardage": 206
      },
      {
        "number": 14,
        "par": 5,
        "si": 2,
        "yardage": 442
      },
      {
        "number": 15,
        "par": 4,
        "si": 6,
        "yardage": 341
      },
      {
        "number": 16,
        "par": 4,
        "si": 10,
        "yardage": 254
      },
      {
        "number": 17,
        "par": 3,
        "si": 14,
        "yardage": 126
      },
      {
        "number": 18,
        "par": 4,
        "si": 8,
        "yardage": 309
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 131,
        "rating": 73.6
      },
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 127,
        "rating": 71.4
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 121,
        "rating": 69.2
      },
      {
        "id": "green",
        "name": "Green",
        "color": "#047857",
        "colors": [
          "#047857"
        ],
        "slope": 114,
        "rating": 66.4
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 101,
        "rating": 63.8
      }
    ]
  },
  {
    "id": "gl_the-wilds-at-cedar-valley",
    "name": "The Wilds At Cedar Valley",
    "city": "Thornton",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 3,
        "si": 1,
        "yardage": 140
      },
      {
        "number": 2,
        "par": 4,
        "si": 2,
        "yardage": 177
      },
      {
        "number": 3,
        "par": 3,
        "si": 3,
        "yardage": 85
      },
      {
        "number": 4,
        "par": 3,
        "si": 4,
        "yardage": 105
      },
      {
        "number": 5,
        "par": 3,
        "si": 5,
        "yardage": 103
      },
      {
        "number": 6,
        "par": 4,
        "si": 6,
        "yardage": 208
      },
      {
        "number": 7,
        "par": 3,
        "si": 7,
        "yardage": 145
      },
      {
        "number": 8,
        "par": 4,
        "si": 8,
        "yardage": 212
      },
      {
        "number": 9,
        "par": 3,
        "si": 9,
        "yardage": 80
      },
      {
        "number": 10,
        "par": 4,
        "si": 10,
        "yardage": 204
      },
      {
        "number": 11,
        "par": 4,
        "si": 11,
        "yardage": 202
      },
      {
        "number": 12,
        "par": 4,
        "si": 12,
        "yardage": 208
      },
      {
        "number": 13,
        "par": 3,
        "si": 13,
        "yardage": 138
      },
      {
        "number": 14,
        "par": 3,
        "si": 14,
        "yardage": 100
      },
      {
        "number": 15,
        "par": 3,
        "si": 15,
        "yardage": 126
      },
      {
        "number": 16,
        "par": 4,
        "si": 16,
        "yardage": 202
      },
      {
        "number": 17,
        "par": 4,
        "si": 17,
        "yardage": 202
      },
      {
        "number": 18,
        "par": 3,
        "si": 18,
        "yardage": 95
      }
    ]
  },
  {
    "id": "gl_thunder-highlands-golf-club",
    "name": "Thunder Highlands Golf Club",
    "city": "Thunder Beach",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 3,
        "si": 1,
        "yardage": 151
      },
      {
        "number": 2,
        "par": 4,
        "si": 2,
        "yardage": 227
      },
      {
        "number": 3,
        "par": 4,
        "si": 3,
        "yardage": 253
      },
      {
        "number": 4,
        "par": 3,
        "si": 4,
        "yardage": 141
      },
      {
        "number": 5,
        "par": 4,
        "si": 5,
        "yardage": 190
      }
    ]
  },
  {
    "id": "gl_osprey-valley-heathlands",
    "name": "Osprey Valley Heathlands",
    "city": "Caledon",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 3,
        "yardage": 470
      },
      {
        "number": 2,
        "par": 3,
        "si": 15,
        "yardage": 121
      },
      {
        "number": 3,
        "par": 4,
        "si": 7,
        "yardage": 347
      },
      {
        "number": 4,
        "par": 5,
        "si": 5,
        "yardage": 435
      },
      {
        "number": 5,
        "par": 4,
        "si": 9,
        "yardage": 312
      },
      {
        "number": 6,
        "par": 3,
        "si": 17,
        "yardage": 116
      },
      {
        "number": 7,
        "par": 4,
        "si": 1,
        "yardage": 353
      },
      {
        "number": 8,
        "par": 4,
        "si": 11,
        "yardage": 317
      },
      {
        "number": 9,
        "par": 5,
        "si": 13,
        "yardage": 420
      },
      {
        "number": 10,
        "par": 4,
        "si": 10,
        "yardage": 308
      },
      {
        "number": 11,
        "par": 4,
        "si": 6,
        "yardage": 313
      },
      {
        "number": 12,
        "par": 4,
        "si": 14,
        "yardage": 274
      },
      {
        "number": 13,
        "par": 3,
        "si": 16,
        "yardage": 134
      },
      {
        "number": 14,
        "par": 4,
        "si": 4,
        "yardage": 355
      },
      {
        "number": 15,
        "par": 4,
        "si": 8,
        "yardage": 320
      },
      {
        "number": 16,
        "par": 3,
        "si": 18,
        "yardage": 87
      },
      {
        "number": 17,
        "par": 5,
        "si": 2,
        "yardage": 442
      },
      {
        "number": 18,
        "par": 3,
        "si": 12,
        "yardage": 124
      }
    ],
    "tees": [
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 133,
        "rating": 72.8
      }
    ]
  },
  {
    "id": "gl_osprey-valley-hoot",
    "name": "Osprey Valley Hoot",
    "city": "Caledon",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 7,
        "yardage": 425
      },
      {
        "number": 2,
        "par": 4,
        "si": 9,
        "yardage": 280
      },
      {
        "number": 3,
        "par": 4,
        "si": 5,
        "yardage": 325
      },
      {
        "number": 4,
        "par": 3,
        "si": 17,
        "yardage": 116
      },
      {
        "number": 5,
        "par": 4,
        "si": 1,
        "yardage": 363
      },
      {
        "number": 6,
        "par": 5,
        "si": 11,
        "yardage": 388
      },
      {
        "number": 7,
        "par": 4,
        "si": 3,
        "yardage": 345
      },
      {
        "number": 8,
        "par": 3,
        "si": 15,
        "yardage": 120
      },
      {
        "number": 9,
        "par": 4,
        "si": 14,
        "yardage": 320
      },
      {
        "number": 10,
        "par": 3,
        "si": 16,
        "yardage": 124
      },
      {
        "number": 11,
        "par": 5,
        "si": 2,
        "yardage": 390
      },
      {
        "number": 12,
        "par": 4,
        "si": 14,
        "yardage": 274
      },
      {
        "number": 13,
        "par": 5,
        "si": 4,
        "yardage": 414
      },
      {
        "number": 14,
        "par": 4,
        "si": 6,
        "yardage": 318
      },
      {
        "number": 15,
        "par": 3,
        "si": 18,
        "yardage": 82
      },
      {
        "number": 16,
        "par": 4,
        "si": 8,
        "yardage": 324
      },
      {
        "number": 17,
        "par": 4,
        "si": 12,
        "yardage": 224
      },
      {
        "number": 18,
        "par": 4,
        "si": 10,
        "yardage": 308
      }
    ],
    "tees": [
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 148,
        "rating": 75.4
      },
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 144,
        "rating": 73.2
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 139,
        "rating": 70.8
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 134,
        "rating": 68.9
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 123,
        "rating": 70.3
      }
    ]
  },
  {
    "id": "gl_osprey-valley-toot",
    "name": "Osprey Valley Toot",
    "city": "Caledon",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 7,
        "yardage": 456
      },
      {
        "number": 2,
        "par": 4,
        "si": 1,
        "yardage": 350
      },
      {
        "number": 3,
        "par": 4,
        "si": 3,
        "yardage": 326
      },
      {
        "number": 4,
        "par": 3,
        "si": 17,
        "yardage": 84
      },
      {
        "number": 5,
        "par": 4,
        "si": 11,
        "yardage": 368
      },
      {
        "number": 6,
        "par": 4,
        "si": 11,
        "yardage": 242
      },
      {
        "number": 7,
        "par": 3,
        "si": 15,
        "yardage": 106
      },
      {
        "number": 8,
        "par": 5,
        "si": 5,
        "yardage": 430
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 346
      },
      {
        "number": 10,
        "par": 4,
        "si": 10,
        "yardage": 326
      },
      {
        "number": 11,
        "par": 3,
        "si": 16,
        "yardage": 112
      },
      {
        "number": 12,
        "par": 4,
        "si": 12,
        "yardage": 280
      },
      {
        "number": 13,
        "par": 5,
        "si": 4,
        "yardage": 462
      },
      {
        "number": 14,
        "par": 3,
        "si": 18,
        "yardage": 110
      },
      {
        "number": 15,
        "par": 4,
        "si": 14,
        "yardage": 282
      },
      {
        "number": 16,
        "par": 4,
        "si": 2,
        "yardage": 334
      },
      {
        "number": 17,
        "par": 4,
        "si": 6,
        "yardage": 304
      },
      {
        "number": 18,
        "par": 5,
        "si": 8,
        "yardage": 454
      }
    ],
    "tees": [
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 141,
        "rating": 74.2
      },
      {
        "id": "black",
        "name": "Black",
        "color": "#111827",
        "colors": [
          "#111827"
        ],
        "slope": 135,
        "rating": 72.6
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 129,
        "rating": 70.7
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 122,
        "rating": 68.7
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 122,
        "rating": 70.6
      }
    ]
  },
  {
    "id": "gl_trehaven-golf-and-country-club",
    "name": "Trehaven Golf And Country Club",
    "city": "Hawkestone",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 9,
        "yardage": 265
      },
      {
        "number": 2,
        "par": 4,
        "si": 13,
        "yardage": 242
      },
      {
        "number": 3,
        "par": 3,
        "si": 17,
        "yardage": 110
      },
      {
        "number": 4,
        "par": 5,
        "si": 1,
        "yardage": 399
      },
      {
        "number": 5,
        "par": 4,
        "si": 7,
        "yardage": 314
      },
      {
        "number": 6,
        "par": 4,
        "si": 11,
        "yardage": 250
      },
      {
        "number": 7,
        "par": 3,
        "si": 15,
        "yardage": 156
      },
      {
        "number": 8,
        "par": 4,
        "si": 5,
        "yardage": 331
      },
      {
        "number": 9,
        "par": 5,
        "si": 3,
        "yardage": 417
      },
      {
        "number": 10,
        "par": 5,
        "si": 6,
        "yardage": 408
      },
      {
        "number": 11,
        "par": 4,
        "si": 8,
        "yardage": 316
      },
      {
        "number": 12,
        "par": 3,
        "si": 12,
        "yardage": 116
      },
      {
        "number": 13,
        "par": 4,
        "si": 14,
        "yardage": 275
      },
      {
        "number": 14,
        "par": 5,
        "si": 2,
        "yardage": 425
      },
      {
        "number": 15,
        "par": 3,
        "si": 18,
        "yardage": 66
      },
      {
        "number": 16,
        "par": 5,
        "si": 4,
        "yardage": 469
      },
      {
        "number": 17,
        "par": 4,
        "si": 10,
        "yardage": 316
      },
      {
        "number": 18,
        "par": 3,
        "si": 16,
        "yardage": 127
      }
    ],
    "tees": [
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 110,
        "rating": 66.5
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 115,
        "rating": 69
      }
    ]
  },
  {
    "id": "gl_vespra-hills-golf-club-18-hole",
    "name": "Vespra Hills Golf Club 18 Hole",
    "city": "Minesing",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 330
      },
      {
        "number": 2,
        "par": 4,
        "si": 5,
        "yardage": 322
      },
      {
        "number": 3,
        "par": 3,
        "si": 15,
        "yardage": 122
      },
      {
        "number": 4,
        "par": 5,
        "si": 7,
        "yardage": 329
      },
      {
        "number": 5,
        "par": 3,
        "si": 13,
        "yardage": 127
      },
      {
        "number": 6,
        "par": 4,
        "si": 3,
        "yardage": 335
      },
      {
        "number": 7,
        "par": 3,
        "si": 17,
        "yardage": 100
      },
      {
        "number": 8,
        "par": 5,
        "si": 9,
        "yardage": 388
      },
      {
        "number": 9,
        "par": 4,
        "si": 11,
        "yardage": 334
      },
      {
        "number": 10,
        "par": 4,
        "si": 6,
        "yardage": 259
      },
      {
        "number": 11,
        "par": 3,
        "si": 14,
        "yardage": 127
      },
      {
        "number": 12,
        "par": 4,
        "si": 2,
        "yardage": 351
      },
      {
        "number": 13,
        "par": 4,
        "si": 4,
        "yardage": 341
      },
      {
        "number": 14,
        "par": 5,
        "si": 10,
        "yardage": 439
      },
      {
        "number": 15,
        "par": 4,
        "si": 12,
        "yardage": 287
      },
      {
        "number": 16,
        "par": 3,
        "si": 18,
        "yardage": 120
      },
      {
        "number": 17,
        "par": 4,
        "si": 16,
        "yardage": 291
      },
      {
        "number": 18,
        "par": 4,
        "si": 8,
        "yardage": 241
      }
    ],
    "tees": [
      {
        "id": "stillvalley-sandhills-iv",
        "name": "StillValley/SandHills - IV",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 132,
        "rating": 73.4
      },
      {
        "id": "homestead-stillvalley-iv",
        "name": "Homestead/StillValley - IV",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 133,
        "rating": 73.1
      },
      {
        "id": "sandhills-homestead-iv",
        "name": "SandHills/Homestead - IV",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 130,
        "rating": 71.5
      },
      {
        "id": "homestead-stillvalley-iii",
        "name": "Homestead/StillValley - III",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 130,
        "rating": 70.7
      },
      {
        "id": "stillvalley-sandhills-iii",
        "name": "StillValley/SandHills - III",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 127,
        "rating": 70.5
      },
      {
        "id": "sandhills-homestead-iii",
        "name": "SandHills/Homestead - III",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 124,
        "rating": 69
      },
      {
        "id": "stillvalley-sandhills-ii",
        "name": "StillValley/SandHills - II",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 125,
        "rating": 68.5
      },
      {
        "id": "homestead-stillvalley-ii",
        "name": "Homestead/StillValley - II",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 126,
        "rating": 68.4
      },
      {
        "id": "sandhills-homestead-ii",
        "name": "SandHills/Homestead - II",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 118,
        "rating": 66.5
      },
      {
        "id": "homestead-stillvalley-i",
        "name": "Homestead/StillValley - I",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 131,
        "rating": 70.7
      },
      {
        "id": "stillvalley-sandhills-i",
        "name": "StillValley/SandHills - I",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 125,
        "rating": 70.9
      },
      {
        "id": "sandhills-homestead-i",
        "name": "SandHills/Homestead - I",
        "color": "#9ca3af",
        "colors": [
          "#9ca3af"
        ],
        "slope": 122,
        "rating": 68.2
      }
    ]
  },
  {
    "id": "gl_walkerton-golf-and-country-club",
    "name": "Walkerton Golf And Country Club",
    "city": "Walkerton",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 11,
        "yardage": 289
      },
      {
        "number": 2,
        "par": 5,
        "si": 13,
        "yardage": 408
      },
      {
        "number": 3,
        "par": 4,
        "si": 5,
        "yardage": 245
      },
      {
        "number": 4,
        "par": 4,
        "si": 1,
        "yardage": 310
      },
      {
        "number": 5,
        "par": 5,
        "si": 7,
        "yardage": 350
      },
      {
        "number": 6,
        "par": 3,
        "si": 17,
        "yardage": 120
      },
      {
        "number": 7,
        "par": 4,
        "si": 3,
        "yardage": 241
      },
      {
        "number": 8,
        "par": 3,
        "si": 9,
        "yardage": 128
      },
      {
        "number": 9,
        "par": 4,
        "si": 15,
        "yardage": 236
      }
    ]
  },
  {
    "id": "gl_whispering-hills-golf-club",
    "name": "Whispering Hills Golf Club",
    "city": "Hanover",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 12,
        "yardage": 327
      },
      {
        "number": 2,
        "par": 5,
        "si": 2,
        "yardage": 455
      },
      {
        "number": 3,
        "par": 5,
        "si": 4,
        "yardage": 474
      },
      {
        "number": 4,
        "par": 4,
        "si": 6,
        "yardage": 313
      },
      {
        "number": 5,
        "par": 3,
        "si": 18,
        "yardage": 160
      },
      {
        "number": 6,
        "par": 4,
        "si": 8,
        "yardage": 311
      },
      {
        "number": 7,
        "par": 3,
        "si": 14,
        "yardage": 135
      },
      {
        "number": 8,
        "par": 4,
        "si": 10,
        "yardage": 365
      },
      {
        "number": 9,
        "par": 3,
        "si": 16,
        "yardage": 185
      },
      {
        "number": 10,
        "par": 3,
        "si": 7,
        "yardage": 164
      },
      {
        "number": 11,
        "par": 3,
        "si": 15,
        "yardage": 207
      },
      {
        "number": 12,
        "par": 4,
        "si": 5,
        "yardage": 208
      },
      {
        "number": 13,
        "par": 4,
        "si": 3,
        "yardage": 351
      },
      {
        "number": 14,
        "par": 5,
        "si": 1,
        "yardage": 450
      },
      {
        "number": 15,
        "par": 3,
        "si": 13,
        "yardage": 191
      },
      {
        "number": 16,
        "par": 4,
        "si": 9,
        "yardage": 296
      },
      {
        "number": 17,
        "par": 4,
        "si": 11,
        "yardage": 272
      },
      {
        "number": 18,
        "par": 3,
        "si": 17,
        "yardage": 131
      }
    ],
    "tees": [
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 117,
        "rating": 67.5
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 111,
        "rating": 65.7
      },
      {
        "id": "yellow",
        "name": "Yellow",
        "color": "#fbbf24",
        "colors": [
          "#fbbf24"
        ],
        "slope": 104,
        "rating": 68.4
      }
    ]
  },
  {
    "id": "gl_wiarton-golf-club",
    "name": "Wiarton Golf Club",
    "city": "Georgian Bluffs",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 1,
        "yardage": 218
      },
      {
        "number": 2,
        "par": 5,
        "si": 2,
        "yardage": 370
      },
      {
        "number": 3,
        "par": 4,
        "si": 3,
        "yardage": 200
      },
      {
        "number": 4,
        "par": 3,
        "si": 4,
        "yardage": 150
      },
      {
        "number": 5,
        "par": 4,
        "si": 5,
        "yardage": 260
      },
      {
        "number": 6,
        "par": 3,
        "si": 6,
        "yardage": 100
      },
      {
        "number": 7,
        "par": 4,
        "si": 7,
        "yardage": 265
      },
      {
        "number": 8,
        "par": 4,
        "si": 8,
        "yardage": 250
      },
      {
        "number": 9,
        "par": 4,
        "si": 9,
        "yardage": 320
      }
    ]
  },
  {
    "id": "gl_willow-greens-golf-club",
    "name": "Willow Greens Golf Club",
    "city": "Sutton",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 3,
        "si": 17,
        "yardage": 103
      },
      {
        "number": 2,
        "par": 4,
        "si": 13,
        "yardage": 225
      },
      {
        "number": 3,
        "par": 3,
        "si": 5,
        "yardage": 120
      },
      {
        "number": 4,
        "par": 3,
        "si": 1,
        "yardage": 129
      },
      {
        "number": 5,
        "par": 4,
        "si": 9,
        "yardage": 210
      },
      {
        "number": 6,
        "par": 3,
        "si": 15,
        "yardage": 96
      },
      {
        "number": 7,
        "par": 3,
        "si": 7,
        "yardage": 100
      },
      {
        "number": 8,
        "par": 3,
        "si": 11,
        "yardage": 107
      },
      {
        "number": 9,
        "par": 3,
        "si": 3,
        "yardage": 127
      }
    ],
    "tees": [
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 92,
        "rating": 28.3
      },
      {
        "id": "red",
        "name": "REd",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 93,
        "rating": 29.6
      }
    ]
  },
  {
    "id": "gl_woodington-lake-legacy-course",
    "name": "Woodington Lake Legacy Course",
    "city": "Tottenham",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 5,
        "si": 13,
        "yardage": 415
      },
      {
        "number": 2,
        "par": 4,
        "si": 1,
        "yardage": 322
      },
      {
        "number": 3,
        "par": 4,
        "si": 9,
        "yardage": 305
      },
      {
        "number": 4,
        "par": 3,
        "si": 11,
        "yardage": 118
      },
      {
        "number": 5,
        "par": 4,
        "si": 7,
        "yardage": 290
      },
      {
        "number": 6,
        "par": 4,
        "si": 5,
        "yardage": 320
      },
      {
        "number": 7,
        "par": 5,
        "si": 3,
        "yardage": 421
      },
      {
        "number": 8,
        "par": 3,
        "si": 15,
        "yardage": 90
      },
      {
        "number": 9,
        "par": 4,
        "si": 17,
        "yardage": 285
      },
      {
        "number": 10,
        "par": 4,
        "si": 8,
        "yardage": 328
      },
      {
        "number": 11,
        "par": 4,
        "si": 2,
        "yardage": 323
      },
      {
        "number": 12,
        "par": 3,
        "si": 10,
        "yardage": 130
      },
      {
        "number": 13,
        "par": 4,
        "si": 4,
        "yardage": 318
      },
      {
        "number": 14,
        "par": 5,
        "si": 12,
        "yardage": 398
      },
      {
        "number": 15,
        "par": 3,
        "si": 18,
        "yardage": 92
      },
      {
        "number": 16,
        "par": 4,
        "si": 6,
        "yardage": 307
      },
      {
        "number": 17,
        "par": 4,
        "si": 16,
        "yardage": 285
      },
      {
        "number": 18,
        "par": 5,
        "si": 14,
        "yardage": 390
      }
    ],
    "tees": [
      {
        "id": "gold",
        "name": "Gold",
        "color": "#d4a017",
        "colors": [
          "#d4a017"
        ],
        "slope": 146,
        "rating": 76.9
      },
      {
        "id": "green",
        "name": "Green",
        "color": "#047857",
        "colors": [
          "#047857"
        ],
        "slope": 138,
        "rating": 72.9
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 130,
        "rating": 70.8
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 123,
        "rating": 67.8
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 124,
        "rating": 70
      }
    ]
  },
  {
    "id": "gl_woodington-lake-legend-course",
    "name": "Woodington Lake Legend Course",
    "city": "Tottenham",
    "region": "ON",
    "country": "Canada",
    "holes": [
      {
        "number": 1,
        "par": 4,
        "si": 3,
        "yardage": 309
      },
      {
        "number": 2,
        "par": 5,
        "si": 7,
        "yardage": 401
      },
      {
        "number": 3,
        "par": 3,
        "si": 13,
        "yardage": 91
      },
      {
        "number": 4,
        "par": 5,
        "si": 1,
        "yardage": 434
      },
      {
        "number": 5,
        "par": 4,
        "si": 5,
        "yardage": 335
      },
      {
        "number": 6,
        "par": 3,
        "si": 9,
        "yardage": 149
      },
      {
        "number": 7,
        "par": 4,
        "si": 17,
        "yardage": 253
      },
      {
        "number": 8,
        "par": 4,
        "si": 11,
        "yardage": 298
      },
      {
        "number": 9,
        "par": 4,
        "si": 15,
        "yardage": 313
      },
      {
        "number": 10,
        "par": 4,
        "si": 14,
        "yardage": 310
      },
      {
        "number": 11,
        "par": 3,
        "si": 16,
        "yardage": 122
      },
      {
        "number": 12,
        "par": 5,
        "si": 8,
        "yardage": 462
      },
      {
        "number": 13,
        "par": 4,
        "si": 4,
        "yardage": 315
      },
      {
        "number": 14,
        "par": 4,
        "si": 12,
        "yardage": 300
      },
      {
        "number": 15,
        "par": 4,
        "si": 2,
        "yardage": 314
      },
      {
        "number": 16,
        "par": 3,
        "si": 18,
        "yardage": 129
      },
      {
        "number": 17,
        "par": 5,
        "si": 10,
        "yardage": 412
      },
      {
        "number": 18,
        "par": 4,
        "si": 6,
        "yardage": 308
      }
    ],
    "tees": [
      {
        "id": "green",
        "name": "Green",
        "color": "#047857",
        "colors": [
          "#047857"
        ],
        "slope": 145,
        "rating": 74.3
      },
      {
        "id": "blue",
        "name": "Blue",
        "color": "#1e3a8a",
        "colors": [
          "#1e3a8a"
        ],
        "slope": 138,
        "rating": 71.4
      },
      {
        "id": "white",
        "name": "White",
        "color": "#e5e7eb",
        "colors": [
          "#e5e7eb"
        ],
        "slope": 128,
        "rating": 69.4
      },
      {
        "id": "red",
        "name": "Red",
        "color": "#b91c1c",
        "colors": [
          "#b91c1c"
        ],
        "slope": 123,
        "rating": 71.7
      }
    ]
  }
];
